<template>
  <div class="comRelBox">
    <div class="searchWrap">
      <div class="row1">
        <div class="itemWrap">
          <h3 class="branchName">{{ FullComName }}</h3>
        </div>
        <div class="itemWrap" style="justify-content: flex-end; text-align:right;">
          <el-button type="danger" icon="el-icon-tickets" @click="exportPDF">匯出</el-button>
        </div>
      </div>
    </div>
    <div class="tabsBox">
      <el-tabs tab-position="top" style="background:transparent;" stretch @tab-click="handleTabClick" v-model="activeTabName">
        <!-- 稅藉基本資料tab -->
        <el-tab-pane v-if="tabsList[0] && tabsList[0].show" name="tab0">
          <span slot="label">
            <i class="el-icon-date" style="margin-right:20px;"></i>
            {{ tabsList[0] && tabsList[0].name }}
          </span>
          <div class="taxContent">
            <div class="contentRight">
              <label style="font-size:18px;font-weight:600;">異動時間</label>
              <el-select v-model="dataSelectedDate" placeholder="請選擇異動時間" style="width:10rem;margin: 0 0 1rem 1rem;" @change="handleDateChange">
                <el-option v-for="item in dataHistoryList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                  <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">項目</div>
                  <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
                </div>
              </div>
              <el-descriptions :column="1" :data="profileList" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
                <el-descriptions-item v-for="(item, index) in profileList" :key="index" :label="item.title">
                  <span v-if="!item.isHtml">{{ item.value }}</span>
                  <span v-else v-html="item.htmlValue"></span>
                </el-descriptions-item>
              </el-descriptions>
            </div>
            <div class="contentLeft">
              <div id="map"></div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 公司概況表tab -->
        <el-tab-pane v-if="tabsList[14] && tabsList[14].show" name="tab14">
          <span slot="label">
            <i class="el-icon-date" style="margin-right:20px;"></i>
            {{ tabsList[14] && tabsList[14].name }}
          </span>
          <div v-if="!comBriefVisible">暫無數據</div>
          <div class="overviewContent" v-if="comBriefVisible">
            <div class="exportBox">
              <el-button v-if="allowExportXls" type="primary" icon="el-icon-tickets" @click="exportBizExcel">匯出公司概況表(excel)</el-button>
              <el-button type="danger" icon="el-icon-tickets" @click="exportBizPDF">匯出公司概況表(pdf)</el-button>
            </div>
            <div class="section">
              <h2>一、客戶基本資料</h2>
              <div class="sectionItem">
                <el-descriptions v-if="biz_info_visible">
                  <el-descriptions-item label="公司名稱">{{ basic_info.CUS_NAME }}</el-descriptions-item>
                  <el-descriptions-item label="公司英文名稱">{{ basic_info.CUS_ENG_NAME }}</el-descriptions-item>
                  <el-descriptions-item label="公司統一編號">{{ basic_info.CUS_IDN }}</el-descriptions-item>
                  <el-descriptions-item label="公司設立日">{{ basic_info.CUS_BIRTHDAY }}</el-descriptions-item>
                  <el-descriptions-item label="國別">{{ basic_info.CUS_COUNTRY_CODE }}</el-descriptions-item>
                  <el-descriptions-item label="負責人">{{ basic_info.CUS_REP_NAME }}</el-descriptions-item>
                  <el-descriptions-item label="行業別">{{ basic_info.CUS_IDU_NAME }}</el-descriptions-item>
                  <el-descriptions-item label="組織型態">{{ basic_info.CUS_ORG_TYPE_NAME }}</el-descriptions-item>
                  <el-descriptions-item label="客戶等級">{{ basic_info.CUS_GRADE }}</el-descriptions-item>
                  <el-descriptions-item label="利害關係人">{{ basic_info.INTEREST_REL }}</el-descriptions-item>
                  <el-descriptions-item label="債務協商">{{ basic_info.NOTE_L5 }}</el-descriptions-item>
                </el-descriptions>
                <div v-else style="width: 100%;">
                  <el-table
                    border
                    :cell-style="{ padding: '3px' }"
                    :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                    :row-class-name="getCreditSubTotalRowClass"
                    style="width: 100%"
                    empty-text="暫無數據"
                    :data="emptyArray"
                    :show-header="false"
                  ></el-table>
                </div>
              </div>
            </div>
            <div class="section2">
              <h2>二、營業狀況</h2>
              <div class="sectionHeaderRow">
                <h3 style="margin-bottom:15px;">個體營業狀況</h3>
                <div class="unitText">單位:新臺幣千元</div>
              </div>
              <el-table
                ref="multipleTable"
                border
                :cell-style="{ padding: '3px' }"
                :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                style="width: 100%"
                empty-text="暫無數據"
                :data="business_status.individual"
              >
                <el-table-column label="年度" prop="DATE_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業收入" prop="SD1_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="成長率" prop="SD2_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業毛利" prop="SD3_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業利益" prop="SD4_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業外收支淨額" prop="SD9_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="稅前損益" prop="SD7_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="稅前損益率" prop="SD8_IFRS" min-width="12.5%"></el-table-column>
              </el-table>
              <h4>{{ business_status.desc_IFRS }}</h4>
              <div class="sectionHeaderRow">
                <h3 style="margin-bottom:15px;">合併營業狀況(IFRS)</h3>
                <div class="unitText">單位:新臺幣千元</div>
              </div>
              <el-table ref="multipleTable" border :cell-style="{ padding: '3px' }" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }" style="width: 100%" empty-text="暫無數據" :data="business_status.IFRS">
                <el-table-column label="年度" prop="DATE_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業收入" prop="SD1_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="成長率" prop="SD2_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業毛利" prop="SD3_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業利益" prop="SD4_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="營業外收支淨額" prop="SD9_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="稅前損益" prop="SD7_IFRS" min-width="12.5%"></el-table-column>
                <el-table-column class-name="align-right-column" label="稅前損益率" prop="SD8_IFRS" min-width="12.5%"></el-table-column>
              </el-table>
              <!-- <h4>{{ business_status.desc }}</h4>     -->
            </div>

            <div class="section3">
              <h2>三、主要業務貢獻度</h2>
              <div class="sectionHeaderRow">
                <h3>統計起訖日：{{ contribution.period }}</h3>
                <div class="unitText" style="text-decoration: underline;">單位:新臺幣元</div>
              </div>
              <el-table ref="multipleTable" border :cell-style="{ padding: '3px' }" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }" style="width: 100%" empty-text="暫無數據" :data="contribution.detail">
                <el-table-column label="業務群組-產品別" prop="BUS_GROUP_LABEL_DESC" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="平均餘額／交易" prop="PROF_AVE_BALANCE" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="資金運用收入" prop="PROF_FUND_INCOME" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="資金運用成本" prop="PROF_FUND_COST" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="資金運用收益" prop="PROF_FUND_PROF" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="手續費收益" prop="PROF_CMS_PROF" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="其他收入" prop="PROF_OTHER_INCOME" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="兌換收益" prop="PROF_GA_LOS_XC" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="貢獻度" prop="PROF_CLIENT_PROF" min-width="10%"></el-table-column>
              </el-table>
            </div>
            <h4>註：本表相關資料僅列示至單位元，倘有完整數據需求，以CRM3系統為準</h4>
            <h3 style="margin-bottom:15px;">主要業務貢獻度統計</h3>
            <el-descriptions v-if="contribution_statistics_visible">
              <el-descriptions-item label="貢獻度合計">{{ contribution.statistics.ROA_CLIENT_PROF }}</el-descriptions-item>
              <el-descriptions-item label="放款收益">{{ contribution.statistics.ROA_FUND_PROF_LOAN }}</el-descriptions-item>
              <el-descriptions-item label="保證手續費收益">{{ contribution.statistics.ROA_1886 }}</el-descriptions-item>
              <el-descriptions-item label="一般手續費收益">{{ contribution.statistics.ROA_NON1886 }}</el-descriptions-item>
              <el-descriptions-item label="存款收益">{{ contribution.statistics.ROA_FUND_PROF_SAVING }}</el-descriptions-item>
              <el-descriptions-item label="信用卡業務收益">{{ contribution.statistics.ROA_FUND_PROF_IC }}</el-descriptions-item>
              <el-descriptions-item label="融資交易資金運用收益">{{ contribution.statistics.ROA_FUND_PROF_SMS }}</el-descriptions-item>
              <el-descriptions-item label="ROA1">{{ contribution.statistics.ROA1 }}</el-descriptions-item>
              <el-descriptions-item label="ROA2">{{ contribution.statistics.ROA2 }}</el-descriptions-item>
              <el-descriptions-item label="ROA3">{{ contribution.statistics.ROA3 }}</el-descriptions-item>
            </el-descriptions>
            <div v-else>
              <el-table
                border
                :cell-style="{ padding: '3px' }"
                :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                :row-class-name="getCreditSubTotalRowClass"
                style="width: 100%"
                empty-text="暫無數據"
                :data="emptyArray"
                :show-header="false"
              ></el-table>
            </div>

            <div class="section4">
              <div class="sectionHeaderRow">
                <h2>四、授信往來情形</h2>
                <div class="unitText">單位:新臺幣千元</div>
              </div>
              <h3>{{ credit_status.mainCustomer }} ({{ credit_status.mainCustomerID }})</h3>
              <el-table
                ref="multipleTable"
                border
                :cell-style="{ padding: '3px' }"
                :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                :row-class-name="getCreditSubTotalRowClass"
                style="width: 100%"
                empty-text="暫無數據"
                :data="credit_status.main"
              >
                <el-table-column label="分行別" prop="CUS_BRANCH" min-width="10%"></el-table-column>
                <el-table-column label="授信項目" prop="CREDIT_ITEM" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="訂約金額" prop="CONTRACT_AMOUNT" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="授信餘額" prop="CREDIT_BAL" min-width="10%"></el-table-column>
                <el-table-column label="貸款期間" prop="LOAN_TERM" min-width="20%"></el-table-column>
                <el-table-column label="擔保品" prop="COLLATERAL" min-width="10%"></el-table-column>
                <el-table-column label="備註" prop="REMARKS" min-width="10%"></el-table-column>
              </el-table>

              <div v-for="(childItems, idx) in credit_status.child" :key="childItems.CHILD_CUSIDN || idx">
                <h3>{{ childItems[0].CUS_NAME }} ({{ childItems[0].CHILD_CUSIDN }})</h3>
                <el-table
                  ref="multipleTable"
                  border
                  :cell-style="{ padding: '3px' }"
                  :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                  :row-class-name="getCreditSubTotalRowClass"
                  style="width: 100%"
                  empty-text="暫無數據"
                  :data="childItems"
                >
                  <el-table-column label="分行別" prop="CUS_BRANCH" min-width="10%"></el-table-column>
                  <el-table-column label="授信項目" prop="CREDIT_ITEM" min-width="10%"></el-table-column>
                  <el-table-column class-name="align-right-column" label="訂約金額" prop="CONTRACT_AMOUNT" min-width="10%"></el-table-column>
                  <el-table-column class-name="align-right-column" label="授信餘額" prop="CREDIT_BAL" min-width="10%"></el-table-column>
                  <el-table-column label="貸款期間" prop="LOAN_TERM" min-width="20%"></el-table-column>
                  <el-table-column label="擔保品" prop="COLLATERAL" min-width="10%"></el-table-column>
                  <el-table-column label="備註" prop="REMARKS" min-width="10%"></el-table-column>
                </el-table>
              </div>

              <br />
              <el-table
                border
                :cell-style="{ padding: '3px' }"
                :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
                :row-class-name="getCreditSubTotalRowClass"
                style="width: 100%"
                empty-text="暫無數據"
                :data="credit_status.all_subTotal"
                v-if="credit_status.all_subTotal.length > 0"
                :show-header="false"
              >
                <el-table-column label="分行別" prop="CUS_BRANCH" min-width="10%"></el-table-column>
                <el-table-column label="授信項目" prop="SUM_CREDIT_ITEM" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="訂約金額" prop="SUM_CONTRACT_AMOUNT" min-width="10%"></el-table-column>
                <el-table-column class-name="align-right-column" label="授信餘額" prop="SUM_CREDIT_BAL" min-width="10%"></el-table-column>
                <el-table-column label="貸款期間" prop="SUM_LOAN_TERM" min-width="20%"></el-table-column>
                <el-table-column label="擔保品" prop="SUM_COLLATERAL_RATIO" min-width="10%"></el-table-column>
                <el-table-column label="備註" prop="REMARKS" min-width="10%"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

        <!-- 出進口資料tab -->
        <el-tab-pane v-if="tabsList[1] && tabsList[1].show" name="tab1">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[1] && tabsList[1].name }}
          </span>
          <label style="font-size:18px;font-weight:600;">異動時間</label>
          <el-select v-model="ioDataSelectedDate" placeholder="請選擇異動時間" style="width:10rem;margin: 0 0 1rem 1rem;" @change="handleIODataDateChange">
            <el-option v-for="item in ioDataHistoryList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
              <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">項目</div>
              <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
            </div>
          </div>
          <el-descriptions :column="1" :data="ioDataList" :label-style="{ fontWeight: 900, width: '20%' }" :content-style="{ width: '80%' }" size="medium" border>
            <el-descriptions-item v-for="(item, index) in ioDataList" :key="index" :label="item.title">
              <a href="javascript:void(0)" v-if="item.clickable" @click="showDrawer(item.linkType)" style="color: #409EFF; text-decoration: underline;">
                {{ item.value }}
              </a>
              <span v-else>{{ item.value }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <!-- 工廠資料tab -->
        <el-tab-pane v-if="tabsList[2] && tabsList[2].show" name="tab2">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[2] && tabsList[2].name }}
          </span>
          <div v-if="!factoryDataListQuery || !factoryDataListQuery.factory_Data_List || factoryDataListQuery.factory_Data_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in factoryDataListQuery.factory_Data_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.title">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[2].datasource }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="factoryDataListPageChange"
            :pageSize="factoryDataListQuery && factoryDataListQuery.Page_Size ? factoryDataListQuery.Page_Size : 10"
            :propsCurrentPage="factoryDataListQuery && factoryDataListQuery.Page_Num ? factoryDataListQuery.Page_Num : 1"
            :totalLists="factoryDataListQuery && factoryDataListQuery.Total ? factoryDataListQuery.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 供應商資料tab -->
        <el-tab-pane v-if="tabsList[3] && tabsList[3].show" name="tab3">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[3] && tabsList[3].name }}
          </span>
          <div v-if="!apv_supply_Query || !apv_supply_Query.apv_supply_List || apv_supply_Query.apv_supply_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in apv_supply_Query.apv_supply_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[3] && tabsList[3].datasource ? tabsList[3].datasource : "經濟部標準檢驗局" }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="apv_supply_PageChange"
            :pageSize="apv_supply_Query && apv_supply_Query.Page_Size ? apv_supply_Query.Page_Size : 10"
            :propsCurrentPage="apv_supply_Query && apv_supply_Query.Page_Num ? apv_supply_Query.Page_Num : 1"
            :totalLists="apv_supply_Query && apv_supply_Query.Total ? apv_supply_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 對外投資資料tab -->
        <el-tab-pane v-if="tabsList[4] && tabsList[4].show" name="tab4">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[4] && tabsList[4].name }}
          </span>
          <div v-if="!com_invest_Query || !com_invest_Query.com_invest_List || com_invest_Query.com_invest_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in com_invest_Query.com_invest_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[4].datasource }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="com_invest_PageChange"
            :pageSize="com_invest_Query && com_invest_Query.Page_Size ? com_invest_Query.Page_Size : 10"
            :propsCurrentPage="com_invest_Query && com_invest_Query.Page_Num ? com_invest_Query.Page_Num : 1"
            :totalLists="com_invest_Query && com_invest_Query.Total ? com_invest_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 陸資投資資料tab -->
        <el-tab-pane v-if="tabsList[5] && tabsList[5].show" name="tab5">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[5] && tabsList[5].name }}
          </span>
          <div v-if="!china_fund_Query || !china_fund_Query.china_fund_List || china_fund_Query.china_fund_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in china_fund_Query.china_fund_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[5].datasource }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="china_fund_PageChange"
            :pageSize="china_fund_Query && china_fund_Query.Page_Size ? china_fund_Query.Page_Size : 10"
            :propsCurrentPage="china_fund_Query && china_fund_Query.Page_Num ? china_fund_Query.Page_Num : 1"
            :totalLists="china_fund_Query && china_fund_Query.Total ? china_fund_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 赴大陸投資資料tab -->
        <el-tab-pane v-if="tabsList[6] && tabsList[6].show" name="tab6">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[6] && tabsList[6].name }}
          </span>
          <div v-if="!com_invest_china_Query || !com_invest_china_Query.com_invest_china_List || com_invest_china_Query.com_invest_china_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in com_invest_china_Query.com_invest_china_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[6].datasource }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="com_invest_china_PageChange"
            :pageSize="com_invest_china_Query && com_invest_china_Query.Page_Size ? com_invest_china_Query.Page_Size : 10"
            :propsCurrentPage="com_invest_china_Query && com_invest_china_Query.Page_Num ? com_invest_china_Query.Page_Num : 1"
            :totalLists="com_invest_china_Query && com_invest_china_Query.Total ? com_invest_china_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 獲獎資料tab -->
        <el-tab-pane v-if="tabsList[7] && tabsList[7].show" name="tab7">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[7] && tabsList[7].name }}
          </span>
          <div v-if="!award_record_Query || !award_record_Query.award_record_List || award_record_Query.award_record_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in award_record_Query.award_record_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <!--                    <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
                        <el-descriptions-item label="資料日期">
                            {{ tabsList[7].datasource  }}
                        </el-descriptions-item>
                    </el-descriptions>                                        -->
          <Pagination
            @currentChange="award_record_PageChange"
            :pageSize="award_record_Query && award_record_Query.Page_Size ? award_record_Query.Page_Size : 10"
            :propsCurrentPage="award_record_Query && award_record_Query.Page_Num ? award_record_Query.Page_Num : 1"
            :totalLists="award_record_Query && award_record_Query.Total ? award_record_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 認證資料tab -->
        <el-tab-pane v-if="tabsList[8] && tabsList[8].show" name="tab8">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[8] && tabsList[8].name }}
          </span>
          <div v-if="!pro_certify_Query || !pro_certify_Query.pro_certify_List || pro_certify_Query.pro_certify_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in pro_certify_Query.pro_certify_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <!-- <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
                        <el-descriptions-item label="資料日期">
                            {{ tabsList[8].datasource  }}
                        </el-descriptions-item>
                    </el-descriptions>                                         -->
          <Pagination
            @currentChange="pro_certify_PageChange"
            :pageSize="pro_certify_Query && pro_certify_Query.Page_Size ? pro_certify_Query.Page_Size : 10"
            :propsCurrentPage="pro_certify_Query && pro_certify_Query.Page_Num ? pro_certify_Query.Page_Num : 1"
            :totalLists="pro_certify_Query && pro_certify_Query.Total ? pro_certify_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!--領域名稱    -->
        <el-tab-pane v-if="tabsList[9] && tabsList[9].show" name="tab9">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[9] && tabsList[9].name }}
          </span>
          <div v-if="!com_domain_Query || !com_domain_Query.com_domain_List || com_domain_Query.com_domain_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in com_domain_Query.com_domain_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <!-- <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
                        <el-descriptions-item label="資料日期">
                            {{ tabsList[9].datasource  }}
                        </el-descriptions-item>
                    </el-descriptions> -->
          <Pagination
            @currentChange="com_domain_PageChange"
            :pageSize="com_domain_Query && com_domain_Query.Page_Size ? com_domain_Query.Page_Size : 10"
            :propsCurrentPage="com_domain_Query && com_domain_Query.Page_Num ? com_domain_Query.Page_Num : 1"
            :totalLists="com_domain_Query && com_domain_Query.Total ? com_domain_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 品牌商標資料tab -->
        <el-tab-pane v-if="tabsList[10] && tabsList[10].show" name="tab10">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[10].name }}
          </span>
          <div v-if="!brand_prod_Query || !brand_prod_Query.brand_prod_List || brand_prod_Query.brand_prod_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in brand_prod_Query.brand_prod_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <!-- <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
                        <el-descriptions-item label="資料日期">
                            {{ tabsList[10].datasource  }}
                        </el-descriptions-item>
                    </el-descriptions>                                         -->
          <!-- <Pagination @currentChange="brand_prod_PageChange" :pageSize="brand_prod_Query.Page_Size" :propsCurrentPage="brand_prod_Query.Page_Num" :totalLists="brand_prod_Query.Total" ></Pagination>  -->
        </el-tab-pane>
        <!--所在園區    -->
        <el-tab-pane v-if="tabsList[11].show" name="tab11">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[11].name }}
          </span>
          <div v-if="!tech_park_Query || !tech_park_Query.park_name_List || tech_park_Query.park_name_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in tech_park_Query.park_name_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[11].datasource }}
            </el-descriptions-item>
          </el-descriptions>
          <Pagination
            @currentChange="tech_park_PageChange"
            :pageSize="tech_park_Query && tech_park_Query.Page_Size ? tech_park_Query.Page_Size : 10"
            :propsCurrentPage="tech_park_Query && tech_park_Query.Page_Num ? tech_park_Query.Page_Num : 1"
            :totalLists="tech_park_Query && tech_park_Query.Total ? tech_park_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 裁罰資料tab -->
        <el-tab-pane v-if="tabsList[12].show" name="tab12">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[12].name }}
          </span>
          <div v-if="!com_penalty_Query || !com_penalty_Query.com_penalty_List || com_penalty_Query.com_penalty_List.length === 0" style="text-align: center; padding: 20px;">暫無數據</div>
          <div v-for="(row, index) in com_penalty_Query.com_penalty_List" :key="index" style="margin-bottom: 20px;">
            <div style="display: flex; align-items: center; margin-bottom: 10px;">
              <div style="flex: 1; display: grid; grid-template-columns: 20% 80%; background-color: #FFF8DC; border: 1px solid #ddd;">
                <div style="padding: 8px; font-weight: bold; border-right: 1px solid #ddd;">{{ index + 1 }}. 項目</div>
                <div style="padding: 8px; font-weight: bold; text-align: left;">內容</div>
              </div>
            </div>
            <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
              <el-descriptions-item v-for="(item, idx) in row" :key="idx" :label="item.label">
                {{ item.value }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-descriptions style="margin-top: 20px;" :column="1" :label-style="{ fontWeight: 900, width: '20%' }" size="medium" border>
            <el-descriptions-item label="資料來源">
              {{ tabsList[12].datasource }}
            </el-descriptions-item>
          </el-descriptions>

          <Pagination
            @currentChange="com_penalty_PageChange"
            :pageSize="com_penalty_Query && com_penalty_Query.Page_Size ? com_penalty_Query.Page_Size : 10"
            :propsCurrentPage="com_penalty_Query && com_penalty_Query.Page_Num ? com_penalty_Query.Page_Num : 1"
            :totalLists="com_penalty_Query && com_penalty_Query.Total ? com_penalty_Query.Total : 0"
          ></Pagination>
        </el-tab-pane>
        <!-- 關聯新聞tab -->
        <el-tab-pane v-if="tabsList[13].show" name="tab13">
          <span slot="label">
            <i class="el-icon-reading" style="margin-right:20px;"></i>
            {{ tabsList[13].name }}
          </span>
          <div style="display:flex; justify-content:flex-end; margin-bottom:10px;">
            <el-button type="danger" @click="exportNews">匯出新聞</el-button>
          </div>
          <el-table
            ref="relatedNewsTable"
            row-key="DataID"
            :data="!related_news_Query || !related_news_Query.related_news_List ? [] : related_news_Query.related_news_List"
            :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }"
            style="width: 100%;"
            empty-text="暫無數據"
            @selection-change="handleNewsSelectionChange"
          >
            <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
            <el-table-column label="新聞標題" prop="NewsTitle" min-width="30%">
              <template slot-scope="scope">
                <a class="goDetailPage" @click="goNewsDetail(scope.row)">{{ scope.row.NewsTitle }}</a>
              </template>
            </el-table-column>
            <el-table-column label="新聞時間" prop="NewsTime" min-width="15%">
              <template slot-scope="scope">
                {{ scope.row.NewsTime | moment("YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column label="新聞網站" prop="NewsSite" min-width="20%"></el-table-column>
            <el-table-column label="新聞頻道" prop="NewsChannel" min-width="20%"></el-table-column>
          </el-table>
          <Pagination
            @currentChange="related_news_PageChange"
            :pageSize="related_news_Query && related_news_Query.Page_Size ? related_news_Query.Page_Size : 10"
            :propsCurrentPage="related_news_Query && related_news_Query.Page_Num ? related_news_Query.Page_Num : 1"
            :totalLists="related_news_Query && related_news_Query.Total ? related_news_Query.Total : 0"
            :maxPageLimit="50"
          ></Pagination>
        </el-tab-pane>
      </el-tabs>
      <div class="buttonBox">
        <el-button type="danger" @click="closeWin()">
          <font-awesome-icon icon="times" style="margin-right:5px;" />
          關閉
        </el-button>
      </div>
    </div>
    <hr />

    <!-- 添加右側抓屉 (進出口實績) -->
    <el-drawer :title="drawerTitle" :visible.sync="drawerVisible" direction="rtl" size="30%">
      <div style="padding: 20px;">
        <h3>{{ drawerTitle }} 詳細資料</h3>
        <el-table :data="drawerData" stripe style="width: 100%" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center' }">
          <el-table-column prop="date" label="統計年度" width="180"></el-table-column>
          <el-table-column prop="rank" :label="drawerColumnLabel" width="180"></el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <!-- 工廠明細 drawer -->
    <el-drawer :title="detailDrawerTitle" :visible.sync="detailDrawerVisible" direction="rtl" size="40%">
      <div style="padding: 20px;">
        <el-descriptions :column="1" :label-style="{ fontWeight: 900, width: '30%' }" size="medium" border>
          <el-descriptions-item v-for="(item, index) in drawerDataDetail" :key="index" :label="item.label">{{ item.value }}</el-descriptions-item>
        </el-descriptions>
        <div style="margin-top: 20px; text-align: center;">
          <el-button type="primary" @click="detailDrawerVisible = false">關閉</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { notify, handleError } from "@/utils/notify";
import { loadPdfFontBase64, PDF_FONT_MAX_MB } from "@/utils/pdfFontLoader";
import { drawTiledImageWatermark as drawTiledImageWatermarkUtil } from "@/utils/pdfWatermarkTiler";
import { exportCompanyOverviewPdf } from "@/utils/companyOverviewPdfExporter";
import { exportCompanyOverviewExcel } from "@/utils/companyOverviewExcelExporter";
import { isTablet as isTabletDevice } from "@/utils/deviceHelper";
import ExcelJS from "exceljs";

export default {
  components: { Pagination },
  data() {
    return {
      allowExportXls: false,
      activeTabName: "tab0", // 當前激活的tab
      loadedTabs: new Set(["tab0"]), // 已載入資料的tab集合
      userInfo: {},

      ioDataMapping: [
        { key: "A", value: "A (1,000萬(含)美元以上)" },
        { key: "B", value: "B (900萬(含)~1,000萬美元)" },
        { key: "C", value: "C (800萬(含)~900萬美元)" },
        { key: "D", value: "D (700萬(含)~800萬美元)" },
        { key: "E", value: "E (600萬(含)~700萬美元)" },
        { key: "F", value: "F (500萬(含)~600萬美元)" },
        { key: "G", value: "G (400萬(含)~500萬美元)" },
        { key: "H", value: "H (300萬(含)~400萬美元)" },
        { key: "I", value: "I (200萬(含)~300萬美元)" },
        { key: "J", value: "J (100萬(含)~200萬美元)" },
        { key: "K", value: "K (50萬(含)~100萬美元)" },
        { key: "L", value: "L (0萬~50萬美元以下)" },
        { key: "M", value: "M (0萬美元)" },
      ],

      factoryDataListQuery: {
        Page_Size: 10,
        Page_Num: 1,
        factory_Data_List: [],
        Total: 0,
      },

      com_invest_Query: {
        Page_Size: 10,
        Page_Num: 1,
        com_invest_List: [],
        Total: 0,
      },

      com_invest_china_Query: {
        Page_Size: 10,
        Page_Num: 1,
        com_invest_china_List: [],
        Total: 0,
      },

      china_fund_Query: {
        Page_Size: 10,
        Page_Num: 1,
        china_fund_List: [],
        Total: 0,
      },

      pro_certify_Query: {
        Page_Size: 10,
        Page_Num: 1,
        pro_certify_List: [],
        Total: 0,
      },

      award_record_Query: {
        Page_Size: 10,
        Page_Num: 1,
        award_record_List: [],
        Total: 0,
      },

      com_domain_Query: {
        Page_Size: 10,
        Page_Num: 1,
        com_domain_List: [],
        Total: 0,
      },

      com_penalty_Query: {
        Page_Size: 10,
        Page_Num: 1,
        com_penalty_List: [],
        Total: 0,
      },

      brand_prod_Query: {
        Page_Size: 10,
        Page_Num: 1,
        brand_prod_List: [],
        Total: 0,
      },

      tech_park_Query: {
        Page_Size: 10,
        Page_Num: 1,
        park_name_List: [],
        Total: 0,
      },

      apv_supply_Query: {
        Page_Size: 10,
        Page_Num: 1,
        apv_supply_List: [],
        Total: 0,
      },

      related_news_Query: {
        Page_Size: 10,
        Page_Num: 1,
        related_news_List: [],
        Total: 0,
      },
      selectedNewsRows: [],
      selectedNewsMap: {}, // 跨頁勾選用 Map，key 為 DataID
      isRestoringNewsSelection: false, // 恢復勾選時避免觸發 selectionChange

      ioDataList: [],
      ioDataHistoryList: [],
      ioDataSelectedDate: "",

      supplierData: [],

      drawerVisible: false,
      drawerTitle: "",
      drawerColumnLabel: "總進口實績",
      drawerData: [],

      detailDrawerVisible: false,
      detailDrawerTitle: "",
      drawerDataDetail: [],

      selectedDate: "2019-01-01",
      dataHistoryList: [], // 稅籍歷史資料
      dataSelectedDate: "", // 稅籍選擇日期
      nationTaxList: [], // 同一個統編公司的稅籍資料

      mapObj: {},
      mapCom: {},
      // 分行資料

      profileList: [],

      emptyArray: [],
      biz_info_visible: false,
      contribution_statistics_visible: false,

      listQuery: {
        tx_Address: "",
        searchContent: "",
        Page_Size: 10,
        Page_Num: 1,
      },
      branchList: [],

      managerList: [],
      keyword: "台企銀",
      selectedCity: "",
      selectedDistrict: "",
      selectedStreet: "",
      CityList: [],
      DistList: [],
      RoadList: [],
      totalLists: 124,
      tabledata: [],
      latitude: 24.9895,
      longitude: 121.508,
      FullComName: "",
      zoomDegree: 15,
      mapTitle: "CTM Map",
      showCustomer: false,
      selectedBranch: {},
      companyDetail: {}, // 公司詳細資料

      // 公司概況表資料結構
      comBriefVisible: false,
      basic_info: {}, // 公司基本資料
      business_status: {
        individual: [], // 營業狀況-個體營業狀況
        IFRS: [], // 營業狀況-合併營業狀況(IFRS)
        desc: "", // 營業狀況-說明文字
        desc_IFRS: "", // 營業狀況-說明文字(IFRS)
      },
      contribution: {
        // 主要業務貢獻度
        period: "", // 統計起訖日
        detail: [], // 主要業務貢獻度明細
        statistics: {}, // 主要業務貢獻度統計
      },
      credit_status: {
        // 授信往來情形
        mainCustomer: "", // 主要授信往來客戶名稱
        mainCustomerID: "", // 主要授信往來客戶統編
        main: [], // 主要授信往來
        main_subTotal: [], // 主要授信往來小計
        child: [], // 關係戶授信往來
        child_subTotal: [], // 關係戶授信往來小計
        all_subTotal: [], // 全部授信往來小計
      },

      tabsList: [
        { name: "稅籍", show: true, datasource: "" },
        { name: "出進口", show: false, datasource: "" },
        { name: "工廠", show: false, datasource: "" },
        { name: "供應商", show: false, datasource: "" },
        { name: "投資", show: false, datasource: "" },
        { name: "陸資來臺投資", show: false, datasource: "" },
        { name: "赴中國大陸投資", show: false, datasource: "" },
        { name: "獲獎名稱", show: false, datasource: "" },
        { name: "認證名稱", show: false, datasource: "" },
        { name: "領域名稱", show: false, datasource: "" },
        { name: "品牌商標", show: false, datasource: "" },
        { name: "所在園區", show: false, datasource: "" },
        { name: "裁罰警示", show: false, datasource: "" },
        { name: "關聯新聞", show: true, datasource: "" },
        { name: "公司概況表", show: false, datasource: "" },
      ],
    };
  },

  computed: {
    // 計算完整地址
    fullAddress() {
      const detail = this.companyDetail;
      if (!detail || Object.keys(detail).length === 0) {
        return "";
      }

      let address = "";

      // 拼接地址各個部分
      if (detail.City) address += detail.City;
      if (detail.District) address += detail.District;
      if (detail.Village) address += detail.Village;
      if (detail.Street) address += detail.Street;
      if (detail.Lane) address += detail.Lane + "巷";
      if (detail.Alley) address += detail.Alley + "弄";
      if (detail.Nebrh) address += detail.Nebrh + "鄰";
      if (detail.Section) address += detail.Section + "段";
      if (detail.No) address += detail.No + "號";
      if (detail.Floor) address += detail.Floor + "樓";

      return address;
    },
  },

  methods: {
    closeWin() {
      window.close();
    },

    getFunction() {
      const roleName = this.$store.getters.userRole || "";
      // UC、HC、HE、HC1、HE 部門可以選取allowExportXls，其他角色不顯示
      if (roleName.includes("UC") || roleName.includes("HC") || roleName.includes("HE") || roleName.includes("HC1")) {
        this.allowExportXls = true;
      } else {
        this.allowExportXls = false;
      }
    },

    getCreditSubTotalRowClass({ row }) {
      const isSubTotal = row && row.CREDIT_ITEM === "小計";
      const isGrandTotal = row && (row.SUM_CREDIT_ITEM === "總計" || row.CREDIT_ITEM === "總計");
      return isSubTotal || isGrandTotal ? "credit-subtotal-row" : "";
    },

    formatNumberWithThousands(value, removeDecimal = false) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const normalizedValue = typeof value === "string" ? value.replace(/,/g, "").trim() : value;

      if (normalizedValue === "") {
        return "";
      }

      const numericValue = Number(normalizedValue);
      if (!Number.isFinite(numericValue)) {
        return value;
      }

      const formatted = numericValue.toLocaleString();
      if (removeDecimal) {
        return formatted.replace(/\.\d+/g, "");
      }
      return formatted;
    },

    handleIODataDateChange(value) {
      this.ioDataSelectedDate = value;
      this.loadIoDataList(this.unicomnm, value);
    },

    // 匯出：商標品牌資料
    async _exportBrandProdPage(doc, watermarkText, watermarkImage) {
      // 先載入商標資料（一次載入較多筆）
      this.brand_prod_Query.Page_Size = 255; // 臨時設定每頁筆數為100筆以載入更多資料
      await this.loadBrandProdData(this.unicomnm);
      this.brand_prod_Query.Page_Size = 10; // 還原每頁筆數設定
      const list = (this.brand_prod_Query && this.brand_prod_Query.brand_prod_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無商標資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `商標品牌共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("商標品牌資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      // autoTable(doc, {
      //     columns: [
      //         { header: '項目', dataKey: 'field' },
      //         { header: '內容', dataKey: 'value' }
      //     ],
      //     body: [
      //         { field: '資料日期', value: this.tabsList[10].datasource }
      //     ],
      //     startY: currentY,
      //     showHead: 'never',
      //     styles: { font: 'NotoSansTC', fontSize: 10, cellPadding: 2, valign: 'middle' },
      //     headStyles: { font: 'NotoSansTC', fontStyle: 'bold', fillColor: [255, 246, 239], textColor: 60 },
      //     columnStyles: { 0: { cellWidth: 50 } },
      //     margin: { left: 14, right: 14, bottom: 20 },
      //     didDrawPage: () => {
      //         drawWatermarkAndFooter(list.length);
      //     }
      // });
    },

    // === 新增浮水印方法 ===
    addWatermark(doc, text) {
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      try {
        doc.saveGraphicsState();
      } catch (e) {}
      doc.setFontSize(50);
      doc.setTextColor(220, 220, 220);
      try {
        doc.setGState(new doc.GState({ opacity: 0.15 }));
      } catch (e) {}
      doc.text(text, pageWidth / 2, pageHeight / 2, {
        align: "center",
        angle: 45,
      });
      try {
        doc.restoreGraphicsState();
      } catch (e) {}
    },

    drawTiledImageWatermark(doc, watermarkImage, imgFormat, pageWidth, pageHeight, tileW, tileH, gapX, gapY) {
      drawTiledImageWatermarkUtil(doc, watermarkImage, imgFormat, pageWidth, pageHeight, tileW, tileH, gapX, gapY);
    },

    decoratePdfPage(doc, watermarkText, watermarkImage, footerSummary) {
      if (watermarkImage) {
        try {
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const isPng = (watermarkImage || "").indexOf("data:image/png") === 0 || (watermarkImage || "").indexOf("png") >= 0;
          const imgFormat = isPng ? "PNG" : "JPEG";
          const imgProps = doc.getImageProperties ? doc.getImageProperties(watermarkImage) : null;
          const baseTileWidth = Math.min(pageWidth * 0.28, imgProps ? imgProps.width : pageWidth * 0.28);
          const scale = imgProps ? baseTileWidth / imgProps.width : 1;
          const tileW = baseTileWidth;
          const tileH = imgProps ? imgProps.height * scale : baseTileWidth;
          const gapX = tileW * 0.15;
          const gapY = tileH * 0.25;
          this.drawTiledImageWatermark(doc, watermarkImage, imgFormat, pageWidth, pageHeight, tileW, tileH, gapX, gapY);
        } catch (e) {
          console.warn("將浮水印影像寫入 PDF（平鋪）失敗，回退為文字浮水印", e);
          this.addWatermark(doc, watermarkText);
        }
      } else {
        this.addWatermark(doc, watermarkText);
      }

      const pageNum = doc.internal.getCurrentPageInfo().pageNumber;
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`第 ${pageNum} 頁　列印時間：${new Date().toLocaleString("zh-TW")}　${footerSummary}`, 14, pageHeight - 10);
      doc.setTextColor(0);
    },

    // 共用 HTML 文字濾除器
    stripHtml(html) {
      if (!html) return "";
      try {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
      } catch (e) {
        return html
          .replace(/<[^>]*>/g, "")
          .replace(/\s+/g, " ")
          .trim();
      }
    },

    removeEmptyItems(dataList) {
      if (!Array.isArray(dataList)) {
        return [];
      }
      return dataList.filter((item) => {
        // 保留 value 不為空且不為 undefined 的項目
        return item && item.value !== "" && item.value !== undefined && item.value !== null;
      });
    },

    // 處理 tab 切換事件，實現懶加載
    handleTabClick(tab) {
      const tabName = tab.name;

      // 如果該 tab 已經載入過，則不重複載入
      if (this.loadedTabs.has(tabName)) {
        return;
      }

      // 根據不同的 tab 載入對應的資料
      switch (tabName) {
        case "tab0": // 稅藉基本資料
          // 第一個 tab 在初始化時已載入
          break;
        case "tab1": // 出進口資料
          this.loadIoDataList(this.unicomnm);
          break;
        case "tab2": // 工廠資料
          this.loadFactoryDataList(this.unicomnm);
          break;
        case "tab3": // 供應商資料
          this.loadApvSupplyData(this.unicomnm);
          break;
        case "tab4": // 對外投資
          this.loadComInvestData(this.unicomnm);
          break;
        case "tab5": // 陸資來台
          this.loadChinaFundData(this.unicomnm);
          break;
        case "tab6": // 赴大陸投資
          this.loadComInvestChinaData(this.unicomnm);
          break;
        case "tab7": // 獲獎資訊
          this.loadAwardRecordData(this.unicomnm);
          break;
        case "tab8": // 認證名稱
          this.loadProCertifyData(this.unicomnm);
          break;
        case "tab9": // 領域名稱
          this.loadComDomainData(this.unicomnm);
          break;
        case "tab10": // 商標資料
          this.loadBrandProdData(this.unicomnm);
          break;
        case "tab11": // 所在園區
          this.loadParkNameData(this.unicomnm);
          break;
        case "tab12": // 裁罰資料
          this.loadComPenaltyData(this.unicomnm);
          break;
        case "tab13": // 關聯新聞
          this.loadRelatedNewsData(this.unicomnm);
          break;
        case "tab14": // 公司概況表
          this.loadCompanyOverviewData(this.unicomnm);
          // this.loadCompanyOverviewData("TEST");
          break;
      }

      // 標記該 tab 已載入
      this.loadedTabs.add(tabName);
    },

    // 載入供應商資料
    async loadApvSupplyData(UniComNm) {
      // console.log('載入供應商資料...');

      const qry = {
        Page_Size: this.apv_supply_Query.Page_Size,
        Page_Num: this.apv_supply_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "ApvDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_apv_supply(qry);
        // console.log('供應商資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              // { label: "登記地址", value: row.ComRegLoc },
              { label: "通訊地址", value: row.ComContLoc },
              // { label: "核准文號", value: row.ApvNm },
              { label: "核准日期", value: row.ApvDt },
              { label: "生產廠場編號", value: row.FtyRegNm },
              { label: "生產廠場名稱", value: row.FtyName },
              { label: "生產廠場地址", value: row.FtyLoc },
              { label: "生產廠場核可日期", value: row.FtyApvDt },
              { label: "生產廠場生產設備", value: row.FtyProd },
              // { label: "資料來源", value: `經濟部標準檢驗局(${row.DataDt})` }
            ];

            // 移除空值項目，並返回處理後的項目陣列
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[3].datasource = `經濟部標準檢驗局`;
          this.apv_supply_Query.apv_supply_List = processedData;
          this.apv_supply_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入供應商資料失敗:", error);
      }
    },

    // 載入對外投資資料
    async loadComInvestData(UniComNm) {
      console.log("載入對外投資資料...");

      const qry = {
        Page_Size: this.com_invest_Query.Page_Size,
        Page_Num: this.com_invest_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "ApvDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_com_invest(qry);
        // console.log('對外投資資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              { label: "國別", value: row.Nation },
              { label: "業別", value: row.IndusType },
              { label: "對外投資事業名稱(中文)", value: row.ComName },
              { label: "對外投資事業名稱(英文)", value: row.ForEngCom },
              { label: "國外電話", value: row.ForPhoneNm },
              { label: "國外傳真", value: row.ForFoxNm },
              { label: "對外事業地址", value: row.ForComLoc },
              // { label: "國內投資人", value: row.ComName },
              // { label: "國內負責人", value: row.RepName },
              // { label: "國內電話", value: row.PhoneNm },
              // { label: "國內傳真", value: row.FaxNm },
              // { label: "國內地址", value: row.ComLoc },
              // { label: "核准記錄", value: row.ApvRecord },
              { label: "核准日期", value: row.ApvDt },
              { label: "主要營業項目", value: row.MainProd },
              // { label: "資料來源", value: `經濟部(${row.DataDt})` }
            ];

            // 移除空值項目，並返回處理後的項目陣列
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[4].datasource = `經濟部`;
          this.com_invest_Query.com_invest_List = processedData;
          this.com_invest_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入對外投資資料失敗:", error);
      }
    },

    // 載入陸資來台資料
    async loadChinaFundData(UniComNm) {
      // console.log('載入陸資來台資料...');

      const qry = {
        Page_Size: this.china_fund_Query.Page_Size,
        Page_Num: this.china_fund_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "ApvDt",
        SortOrder: "desc",
      };

      try {
        // console.log('陸資來台資料qry:', qry);
        const response = await this.$api.apidata.get_china_fund(qry);
        // console.log('陸資來台資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "國內被投資事業名稱", value: row.ComName },
              // { label: "國內被投資事業登記地址", value: row.ComLoc },
              { label: "核准月年", value: row.ApvDt },
              { label: "陸資投資人名稱", value: row.ChinaComName },
              { label: "投資型態", value: row.InvestType },
              { label: "投資金額（新台幣）", value: row.InvestCap },
              { label: "行業分類", value: row.IndusType },
              { label: "備註", value: row.Memo },
              // { label: "資料來源", value: `經濟部(${row.DataDt})` }
            ];

            // 移除空值項目，並返回處理後的項目陣列
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[5].datasource = `經濟部`;
          this.china_fund_Query.china_fund_List = processedData;
          this.china_fund_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入陸資來台資料失敗:", error);
      }
    },

    // 載入赴大陸投資資料
    async loadComInvestChinaData(UniComNm) {
      // console.log('載入赴大陸投資資料...');

      const qry = {
        Page_Size: this.com_invest_china_Query.Page_Size,
        Page_Num: this.com_invest_china_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "ApvDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_com_invest_china(qry);
        // console.log('赴大陸投資資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "國內投資人", value: row.ComName },
              { label: "核准日期", value: row.ApvDt },
              { label: "大陸投資事業", value: row.ChinaComName },
              { label: "大陸事業地址", value: row.ChinaComLoc },
              { label: "大陸業別", value: row.IndusType },
              // { label: "資料來源", value: `經濟部(${row.DataDt})` }
            ];

            // 移除空值項目，並返回處理後的項目陣列
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[6].datasource = `經濟部`;
          this.com_invest_china_Query.com_invest_china_List = processedData;
          this.com_invest_china_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入赴大陸投資資料失敗:", error);
      }
    },

    // 載入認證名稱資料
    async loadProCertifyData(UniComNm) {
      console.log("載入認證名稱資料...");

      const qry = {
        Page_Size: this.pro_certify_Query.Page_Size,
        Page_Num: this.pro_certify_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "DataDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_pro_certify(qry);
        // console.log('認證名稱資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號/工廠登記編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              { label: "地址", value: row.ComLoc },
              { label: "負責人", value: row.RepName },
              { label: "電話", value: row.PhoneNm },
              { label: "認證名稱", value: row.CertifyName },
              { label: "日期(起)", value: row.StartDt },
              { label: "日期(迄)", value: row.EndDt },
              // { label: "產業", value: row.IndusType },
              { label: "產品", value: row.MainProd },
              // { label: "資料日期", value: row.DataDt }
            ];
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[8].datasource = `${response.data[0]?.DataDt || ""}`;
          this.pro_certify_Query.pro_certify_List = processedData;
          this.pro_certify_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入認證名稱資料失敗:", error);
      }
    },

    // 載入獲獎資訊
    async loadAwardRecordData(UniComNm) {
      console.log("載入獲獎資訊...");

      const qry = {
        Page_Size: this.award_record_Query.Page_Size,
        Page_Num: this.award_record_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "StartDt",
        SortOrder: "desc",
      };
      // console.log('獲獎資訊qry:', qry);
      try {
        const response = await this.$api.apidata.get_award_record(qry);
        // // console.log('獲獎資訊載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              // { label: "地址", value: row.ComLoc },
              { label: "負責人/申請人", value: row.RepName },
              { label: "職稱", value: row.Title },
              { label: "電話", value: row.PhoneNm },
              { label: "行動電話", value: row.MobileNm },
              { label: "聯絡信箱", value: row.ComEmail },
              { label: "獲獎名稱", value: row.AwardName },
              { label: "日期(起)", value: row.StartDt },
              { label: "日期(迄)", value: row.EndDt },
              // { label: "產業", value: row.IndusType },
              { label: "產品", value: row.MainProd },
              { label: "備註", value: row.Memo },
              // { label: "資料日期", value: row.DataDt }
            ];

            // 移除空值項目，並返回處理後的項目陣列
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[7].datasource = `${response.data[0]?.DataDt || ""}`;
          this.award_record_Query.award_record_List = processedData;
          this.award_record_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入獲獎資訊失敗:", error);
      }
    },

    // 載入領域名稱資料
    async loadComDomainData(UniComNm) {
      // console.log('載入領域名稱資料...');

      const qry = {
        Page_Size: this.com_domain_Query.Page_Size,
        Page_Num: this.com_domain_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "DataDt",
        SortOrder: "desc",
      };
      // console.log('領域名稱qry:', qry);
      try {
        const response = await this.$api.apidata.get_com_domain(qry);
        // console.log('領域名稱資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              { label: "地址", value: row.ComLoc },
              { label: "負責人", value: row.RepName },
              { label: "經理人/店長/聯絡人", value: row.MgrName },
              { label: "經理人/店長職稱", value: row.MgrTitle },
              { label: "電話", value: row.PhoneNm },
              { label: "聯絡信箱", value: row.ComEmail },
              { label: "領域名稱", value: row.DomainName },
              { label: "所屬集團", value: row.GroupName },
              { label: "日期(起)", value: row.StartDt },
              { label: "日期(迄)", value: row.EndDt },
              { label: "產業", value: row.IndusType },
              { label: "產品", value: row.MainProd },
              { label: "備註", value: row.Memo },
              // { label: "資料日期", value: row.DataDt }
            ];
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[9].datasource = `${response.data[0]?.DataDt || ""}`;
          this.com_domain_Query.com_domain_List = processedData;
          this.com_domain_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入領域名稱資料失敗:", error);
      }
    },

    // 載入裁罰資料

    async loadComPenaltyData(UniComNm) {
      console.log("載入裁罰資料...");

      const qry = {
        Page_Size: this.com_penalty_Query.Page_Size,
        Page_Num: this.com_penalty_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "StartDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_com_penalty(qry);
        // console.log('裁罰資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              // { label: "公司地址", value: row.ComLoc },
              { label: "負責人", value: row.RepName },
              { label: "警示項目", value: row.AlarmItem },
              { label: "日期(起)", value: row.StartDt },
              { label: "日期(迄)", value: row.EndDt },
              { label: "備註", value: row.Memo },
              // { label: "資料來源", value: `勞動部、環境部、行政院公共工程委員會(${row.DataDt})` }
            ];
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[12].datasource = `勞動部、環境部、行政院公共工程委員會`;
          this.com_penalty_Query.com_penalty_List = processedData;
          this.com_penalty_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入裁罰資料失敗:", error);
      }
    },

    async loadRelatedNewsData(UniComNm) {
      // console.log('載入關聯新聞資料...');
      this.$store.dispatch("loadingHandler", true);

      const qry = {
        Page_Size: this.related_news_Query.Page_Size,
        Page_Num: this.related_news_Query.Page_Num,
        Company: [this.FullComName],
        Start_Date: this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"), // 改成限制最近7天的新聞
        End_Date: this.$moment().format("YYYY-MM-DD"),
      };

      try {
        const response = await this.$api.apimgrs.searchNews(qry);
        // console.log('關聯新聞資料載入結果:', response);
        if (response && response.data) {
          this.related_news_Query.related_news_List = response.data;
          this.related_news_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入關聯新聞資料失敗:", error);
      } finally {
        this.$store.dispatch("loadingHandler", false);
      }
    },

    async related_news_PageChange(val) {
      this.related_news_Query.Page_Num = val;
      // 先設旗標，避免載入新頁時 el-table 觸發 selection-change(空陣列) 把 Map 清掉
      this.isRestoringNewsSelection = true;
      await this.loadRelatedNewsData(this.unicomnm);
      // 換頁後恢復該頁已勾選項目
      this.$nextTick(() => {
        setTimeout(() => {
          const newsTableRef = this.$refs.relatedNewsTable;
          if (newsTableRef && this.related_news_Query.related_news_List) {
            this.related_news_Query.related_news_List.forEach((row) => {
              if (row.DataID !== undefined && this.selectedNewsMap[row.DataID]) {
                newsTableRef.toggleRowSelection(row, true);
              }
            });
          }
          this.isRestoringNewsSelection = false;
        }, 50);
      });
    },

    goNewsDetail(data) {
      // console.log('打開新聞詳情:', data);
      let routeUrl = this.$router.resolve({
        path: "/detailNews",
        query: { id: data.DataID },
      });
      window.open(routeUrl.href, "_blank");
    },

    async exportNews() {
      let exportNewsCount = 0;
      try {
        // 決定匯出來源：有勾選則只匯出勾選項目，否則匯出全部
        const allSelected = Object.values(this.selectedNewsMap);
        const sourceList = allSelected.length > 0 ? allSelected : this.related_news_Query.related_news_List;

        // 檢查是否有新聞資料
        if (!sourceList || sourceList.length === 0) {
          notify({ title: "提示", message: "無新聞資料可匯出", type: "info" });
          return;
        }

        exportNewsCount = sourceList.length;

        // 準備 Excel 資料 - 轉換成簡單的物件陣列
        const excelData = sourceList.map((item) => ({
          新聞標題: item.NewsTitle || "",
          新聞網站: item.NewsSite || "",
          新聞頻道: item.NewsChannel || "",
          新聞作者: item.NewsAuthor || "",
          新聞時間: item.NewsTime ? this.$moment(item.NewsTime).format("YYYY-MM-DD") : "",
          新聞內容: item.NewsContent || "",
        }));

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("關聯新聞");
        worksheet.columns = [
          { header: "新聞標題", key: "新聞標題", width: 25 },
          { header: "新聞網站", key: "新聞網站", width: 20 },
          { header: "新聞頻道", key: "新聞頻道", width: 15 },
          { header: "新聞作者", key: "新聞作者", width: 15 },
          { header: "新聞時間", key: "新聞時間", width: 15 },
          { header: "新聞內容", key: "新聞內容", width: 30 },
        ];
        worksheet.addRows(excelData);

        // 生成檔案名稱
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[:-]/g, "")
          .replace("T", "_");
        const fileName = `${this.FullComName || "公司"}_關聯新聞_${timestamp}.xlsx`;

        const excelBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        const exportCount = sourceList.length;
        const isPartial = Object.keys(this.selectedNewsMap).length > 0;
        notify({ title: "成功", message: `已匯出 ${exportCount} 筆${isPartial ? "勾選" : ""}新聞資料`, type: "success" });
        // console.log('新聞資料匯出成功:', fileName);
      } catch (error) {
        console.error("匯出新聞資料失敗:", error);
        notify({ title: "錯誤", message: `匯出失敗：${error.message || "未知錯誤"}`, type: "error" });
      } finally {
        // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為
        const setAudit = {
          menu_path: ["潛在客戶智能搜尋", "企業標籤搜尋", "關聯新聞"],
          action_type: "export",
          action_name: "匯出",
          details: {
            UniComNm: this.unicomnm,
            FullComName: this.FullComName,
            exported_news_count: exportNewsCount,
          },
        };
        const resp = await this.$api.apimgrs.setAuditLog(setAudit);
      }
    },

    handleNewsSelectionChange(selection) {
      if (this.isRestoringNewsSelection) return;
      // 將當前頁已勾選的加入 Map
      selection.forEach((row) => {
        if (row && row.DataID !== undefined) {
          this.$set(this.selectedNewsMap, row.DataID, row);
        }
      });
      // 將當前頁未勾選的從 Map 移除
      if (this.related_news_Query.related_news_List) {
        this.related_news_Query.related_news_List.forEach((row) => {
          if (row.DataID !== undefined && !selection.find((r) => r.DataID === row.DataID)) {
            this.$delete(this.selectedNewsMap, row.DataID);
          }
        });
      }
      this.selectedNewsRows = Object.values(this.selectedNewsMap);
    },

    shouldShowCompanyProfileNotice(response) {
      const statusCode = Number(response && response.statuscode);
      const message = String((response && response.message) || "");
      const errors = Array.isArray(response && response.errors) ? response.errors.filter((e) => !!e) : [];
      return statusCode === 500 || errors.length > 0 || message.includes("無資料");
    },

    buildCompanyProfileNoticeMessage(errors, fallbackText) {
      if (!Array.isArray(errors) || errors.length === 0) {
        return fallbackText || "查無可顯示內容";
      }
      return this.$createElement(
        "div",
        errors.map((e, i) => this.$createElement("div", { key: `cp-notice-${i}` }, e)),
      );
    },

    showCompanyProfileNotice(response) {
      if (!this.shouldShowCompanyProfileNotice(response)) return;
      const title = String((response && response.message) || "系統通知");
      const errors = Array.isArray(response && response.errors) ? response.errors.filter((e) => !!e) : [];
      const statusCode = Number(response && response.statuscode);
      const fallbackText = title.includes("無資料") ? "目前查無資料" : "目前沒有額外錯誤資訊";
      notify({
        title,
        message: this.buildCompanyProfileNoticeMessage(errors, fallbackText),
        type: statusCode === 500 ? "error" : "warning",
      });
    },

    async loadCompanyOverviewData(UniComNm) {
      // console.log('載入公司概況表資料...');
      // this.$store.dispatch('loadingHandler', true);

      const qry = {
        UniComNm: UniComNm,
      };
      // console.log('公司概況表qry:', qry);

      try {
        let response = {};
        if (UniComNm == "MOCK3") {
          const mockResponse3 = {
            statuscode: 200,
            message: "查詢成功（無資料）",
            data: {
              basic_info: {},
              business_status: [
                {
                  data1: [
                    {
                      ID: 1,
                      CUSTID: "12345678",
                      CASEID: "CASE-MOCK2",
                      IFRS_SRC: "1",
                      DATE_IFRS: "2025",
                      S01_IFRS: "150000",
                      S02_IFRS: "8.5",
                      S03_IFRS: "34000",
                      S04_IFRS: "22000",
                      S07_IFRS: "1000",
                      S08_IFRS: "21000",
                      S09_IFRS: "13.2",
                    },
                    {
                      ID: "",
                      CUSTID: "",
                      CASEID: "",
                      IFRS_SRC: "",
                      DATE_IFRS: "",
                      S01_IFRS: "",
                      S02_IFRS: "",
                      S03_IFRS: "",
                      S04_IFRS: "",
                      S07_IFRS: "",
                      S08_IFRS: "",
                      S09_IFRS: "",
                    },
                  ],
                  data2: [],
                },
              ],
              contribution: {
                detail: {
                  DETAILDATA: [],
                },
                statistics: {
                  DETAILDATA: [],
                },
              },
              credit_status: {
                DETAILDATA: [],
              },
            },
          };
          response = mockResponse3;
        } else {
          response = await this.$api.apidata.get_credit_transaction(qry);
          // console.log('公司概況表資料載入結果:', response);
        }

        const statusCode = Number(response && response.statuscode);
        const payload = response && response.data ? response.data : {};

        if (statusCode === 200 || statusCode === 500) {
          // 處理公司概況表資料，500 也可能帶有可顯示的空殼資料與錯誤明細
          // 共有四個段落資料需要處理
          // 1. 基本資料 basic_info
          this.basic_info = payload.basic_info && Array.isArray(payload.basic_info.DETAILDATA) && payload.basic_info.DETAILDATA.length > 0 ? payload.basic_info.DETAILDATA[0] : {};

          this.biz_info_visible = false;
          Object.keys(this.basic_info).forEach((key) => {
            // 若全部的數字都是 null 或 ""，則不顯示統計區塊
            if (this.basic_info[key] !== null && this.basic_info[key] !== undefined && this.basic_info[key] !== "") {
              this.biz_info_visible = true;
            }
          });

          // 2. 營業狀況 business_status
          // 2.1 個體營業狀況 及 合併營業狀況(IFRS)
          this.business_status.individual = []; // 清空陣列
          this.business_status.IFRS = []; // 清空陣列
          // 先檢查 payload.business_status 是否存在且為陣列，才讀取 data1
          let data1 = null;
          if (Array.isArray(payload.business_status) && payload.business_status.length > 0) {
            data1 = payload.business_status[0].data1;
          }
          if (data1) {
            // console.log('營業狀況data1', data1);
            data1.forEach((item) => {
              item.S01_IFRS = this.formatNumberWithThousands(item.S01_IFRS);
              item.S03_IFRS = this.formatNumberWithThousands(item.S03_IFRS);
              item.S04_IFRS = this.formatNumberWithThousands(item.S04_IFRS);
              item.S07_IFRS = this.formatNumberWithThousands(item.S07_IFRS);
              item.S09_IFRS = this.formatNumberWithThousands(item.S09_IFRS);
              if (item.IFRS_SRC == "1") {
                // 個體IFRS
                const individualItem = {
                  ID: item.ID,
                  CUSTID: item.CUSTID,
                  CASEID: item.CASEID,
                  DATE_IFRS: item.DATE_IFRS,
                  SD1_IFRS: item.S01_IFRS,
                  SD2_IFRS: item.S02_IFRS,
                  SD3_IFRS: item.S03_IFRS,
                  SD4_IFRS: item.S04_IFRS,
                  SD7_IFRS: item.S07_IFRS,
                  SD8_IFRS: item.S08_IFRS,
                  SD9_IFRS: item.S09_IFRS,
                };
                if (individualItem.SD2_IFRS == null || individualItem.SD2_IFRS === undefined || individualItem.SD2_IFRS === "") {
                  individualItem.SD2_IFRS = "";
                } else {
                  individualItem.SD2_IFRS = individualItem.SD2_IFRS + " %";
                }
                if (individualItem.SD8_IFRS == null || individualItem.SD8_IFRS === undefined || individualItem.SD8_IFRS === "") {
                  individualItem.SD8_IFRS = "";
                } else {
                  individualItem.SD8_IFRS = individualItem.SD8_IFRS + " %";
                }
                // DATE_IFRS 長度等於 7 時顯示為 XXX年YY月ZZ日；大於 7 時沿用既有區間格式。
                if (individualItem.DATE_IFRS && individualItem.DATE_IFRS.length === 7) {
                  const year = individualItem.DATE_IFRS.substring(0, 3);
                  const month = individualItem.DATE_IFRS.substring(3, 5);
                  const day = individualItem.DATE_IFRS.substring(5, 7);
                  individualItem.DATE_IFRS = `${year}年${month}月${day}日`;
                } else if (individualItem.DATE_IFRS && individualItem.DATE_IFRS.length > 7) {
                  const year = individualItem.DATE_IFRS.substring(0, 3);
                  const endmonth = individualItem.DATE_IFRS.substring(3, 5);
                  const startmonth = individualItem.DATE_IFRS.substring(7, 9);
                  individualItem.DATE_IFRS = `${year}年${startmonth}月 - ${endmonth}月`;
                }
                this.business_status.individual.push(individualItem);
              }
              if (item.IFRS_SRC == "2") {
                // 合併IFRS
                // console.log('處理合併營業狀況2', item);
                const IFRSItem = {
                  ID: item.ID,
                  CUSTID: item.CUSTID,
                  CASEID: item.CASEID,
                  DATE_IFRS: item.DATE_IFRS,
                  SD1_IFRS: item.S01_IFRS,
                  SD2_IFRS: item.S02_IFRS,
                  SD3_IFRS: item.S03_IFRS,
                  SD4_IFRS: item.S04_IFRS,
                  SD7_IFRS: item.S07_IFRS,
                  SD8_IFRS: item.S08_IFRS,
                  SD9_IFRS: item.S09_IFRS,
                };
                // console.log('IFRSItem2', IFRSItem);
                if (IFRSItem.SD2_IFRS == null || IFRSItem.SD2_IFRS === undefined || IFRSItem.SD2_IFRS === "") {
                  IFRSItem.SD2_IFRS = "";
                } else {
                  IFRSItem.SD2_IFRS = IFRSItem.SD2_IFRS + " %";
                }
                if (IFRSItem.SD8_IFRS == null || IFRSItem.SD8_IFRS === undefined || IFRSItem.SD8_IFRS === "") {
                  IFRSItem.SD8_IFRS = "";
                } else {
                  IFRSItem.SD8_IFRS = IFRSItem.SD8_IFRS + " %";
                }
                if (IFRSItem.DATE_IFRS && IFRSItem.DATE_IFRS.length === 7) {
                  const year = IFRSItem.DATE_IFRS.substring(0, 3);
                  const month = IFRSItem.DATE_IFRS.substring(3, 5);
                  const day = IFRSItem.DATE_IFRS.substring(5, 7);
                  IFRSItem.DATE_IFRS = `${year}年${month}月${day}日`;
                } else if (IFRSItem.DATE_IFRS && IFRSItem.DATE_IFRS.length > 7) {
                  const year = IFRSItem.DATE_IFRS.substring(0, 3);
                  const endmonth = IFRSItem.DATE_IFRS.substring(3, 5);
                  const startmonth = IFRSItem.DATE_IFRS.substring(7, 9);
                  IFRSItem.DATE_IFRS = `${year}年${startmonth}月 - ${endmonth}月`;
                }
                this.business_status.IFRS.push(IFRSItem);
              }
            });
          }

          // 2.2 說明文字
          // 先安全取得 data2，避免 payload 或 business_status 結構缺漏導致 runtime error
          let data2 = null;
          if (Array.isArray(payload.business_status) && payload.business_status.length > 0) {
            data2 = payload.business_status[0].data2;
          }
          const item = Array.isArray(data2) && data2.length > 0 ? data2[0] : null;
          if (item) {
            // console.log('營業狀況data2', item);
            const desc = `${item.R01} 申報營業額 ${item.R02} 千元，與上年度同期比較增加 ${item.R03}％ 為 ${item.R04}年全年度申報營業額 ${item.R05}千元之( ${item.R06}％)。`;
            this.business_status.desc = desc;
            let yearPeriod = "";
            let allyear = "";

            if (item.R01_IFRS && item.R01_IFRS.length > 7) {
              const year = item.R01_IFRS.substring(0, 3);
              const startmonth = item.R01_IFRS.substring(3, 5);
              const endmonth = item.R01_IFRS.substring(6, 8);
              yearPeriod = `${year}年${startmonth}月 ~ ${endmonth}月`;
            }
            // console.log('處理合併營業狀況說明文字的R04_IFRS', item.R04_IFRS);
            if (item.R04_IFRS && item.R04_IFRS.length > 5) {
              const year = item.R04_IFRS.substring(0, 3);
              allyear = `${year}`;
            }

            const r03IfrsNumber = Number(item.R03_IFRS);
            const isR03IfrsNumber = Number.isFinite(r03IfrsNumber);
            const r03IfrsChangeText = isR03IfrsNumber ? (r03IfrsNumber >= 0 ? `增加 ${r03IfrsNumber}％` : `減少 ${Math.abs(r03IfrsNumber)}％`) : `增加 ${item.R03_IFRS}％`;
            const r02IfrsFormatted = this.formatNumberWithThousands(item.R02_IFRS);
            const r05IfrsFormatted = this.formatNumberWithThousands(item.R05_IFRS);

            const desc_IFRS = `${yearPeriod} 申報營業額 ${r02IfrsFormatted} 千元，與上年度同期比較${r03IfrsChangeText} 為 ${allyear}年全年度申報營業額 ${r05IfrsFormatted}千元之(${item.R06_IFRS}％)。`;
            this.business_status.desc_IFRS = desc_IFRS;
          }

          // 3. 主要業務貢獻度 contribution
          const contributionDetail = payload.contribution && payload.contribution.detail && Array.isArray(payload.contribution.detail.DETAILDATA) && payload.contribution.detail.DETAILDATA.length > 0 ? payload.contribution.detail.DETAILDATA[0] : {};
          const startDt = contributionDetail.START_DT || "";
          const endDt = contributionDetail.END_DT || "";
          this.contribution.period = startDt || endDt ? `${startDt}～${endDt}` : "";
          // 3.1 明細
          const bus_group = Array.isArray(contributionDetail.BUS_GROUP) ? contributionDetail.BUS_GROUP : [];
          this.contribution.detail = []; // 清空陣列
          bus_group.forEach((item) => {
            const detailItem = {
              BUS_GROUP_LABEL_DESC: item.BUS_GROUP_LABEL_DESC,
              PROF_AVE_BALANCE: this.formatNumberWithThousands(item.PROF_AVE_BALANCE, true),
              PROF_FUND_INCOME: this.formatNumberWithThousands(item.PROF_FUND_INCOME, true),
              PROF_FUND_COST: this.formatNumberWithThousands(item.PROF_FUND_COST, true),
              PROF_FUND_PROF: this.formatNumberWithThousands(item.PROF_FUND_PROF, true),
              PROF_CMS_PROF: this.formatNumberWithThousands(item.PROF_CMS_PROF, true),
              PROF_OTHER_INCOME: this.formatNumberWithThousands(item.PROF_OTHER_INCOME, true),
              PROF_GA_LOS_XC: this.formatNumberWithThousands(item.PROF_GA_LOS_XC, true),
              PROF_CLIENT_PROF: this.formatNumberWithThousands(item.PROF_CLIENT_PROF, true),
            };
            if (item.BUS_GROUP_LABEL == "0301" || item.BUS_GROUP_LABEL == "0302" || item.BUS_GROUP_LABEL == "0303" || item.BUS_GROUP_LABEL == "1001") {
              detailItem.PROF_AVE_BALANCE = "US" + detailItem.PROF_AVE_BALANCE;
            }
            this.contribution.detail.push(detailItem);
          });

          // 3.2 統計
          const rawContributionStatistics =
            payload.contribution && payload.contribution.statistics && Array.isArray(payload.contribution.statistics.DETAILDATA) && payload.contribution.statistics.DETAILDATA.length > 0 ? payload.contribution.statistics.DETAILDATA[0] : {};

          this.contribution_statistics_visible = false;
          Object.keys(rawContributionStatistics).forEach((key) => {
            // 若全部的數字都是 null 或 ""，則不顯示統計區塊
            if (rawContributionStatistics[key] !== null && rawContributionStatistics[key] !== undefined && rawContributionStatistics[key] !== "") {
              this.contribution_statistics_visible = true;
            }
          });
          // console.log('是否顯示貢獻統計', this.contribution_statistics_visible);

          this.contribution.statistics = {
            ...rawContributionStatistics,
            ROA_CLIENT_PROF: this.formatNumberWithThousands(rawContributionStatistics.ROA_CLIENT_PROF, true),
            ROA_FUND_PROF_LOAN: this.formatNumberWithThousands(rawContributionStatistics.ROA_FUND_PROF_LOAN, true),
            ROA_1886: this.formatNumberWithThousands(rawContributionStatistics.ROA_1886, true),
            ROA_NON1886: this.formatNumberWithThousands(rawContributionStatistics.ROA_NON1886, true),
            ROA_FUND_PROF_SAVING: this.formatNumberWithThousands(rawContributionStatistics.ROA_FUND_PROF_SAVING, true),
            ROA_FUND_PROF_IC: this.formatNumberWithThousands(rawContributionStatistics.ROA_FUND_PROF_IC, true),
            ROA_FUND_PROF_SMS: this.formatNumberWithThousands(rawContributionStatistics.ROA_FUND_PROF_SMS, true),
            ROA1: this.formatNumberWithThousands(rawContributionStatistics.ROA1),
            ROA2: this.formatNumberWithThousands(rawContributionStatistics.ROA2),
            ROA3: this.formatNumberWithThousands(rawContributionStatistics.ROA3),
          };

          // 4. 授信往來情形 credit_status
          this.credit_status.main = []; // 清空陣列
          this.credit_status.child = []; // 清空陣列
          const creditDetail = payload.credit_status && Array.isArray(payload.credit_status.DETAILDATA) && payload.credit_status.DETAILDATA.length > 0 ? payload.credit_status.DETAILDATA[0] : {};
          const mainDetail = Array.isArray(creditDetail.MAIN_DETAILDATA) ? creditDetail.MAIN_DETAILDATA : [];

          if (mainDetail.length > 0) {
            this.credit_status.mainCustomer = mainDetail[0].CUS_NAME || "";
            this.credit_status.mainCustomerID = "(" + mainDetail[0].CUSIDN + ")" || "";
          } else {
            this.credit_status.mainCustomer = "";
            this.credit_status.mainCustomerID = "";
          }
          this.credit_status.main = mainDetail;
          // 修改 LOAN_TERM
          this.credit_status.main.forEach((item) => {
            item.CONTRACT_AMOUNT = this.formatNumberWithThousands(item.CONTRACT_AMOUNT);
            item.CREDIT_BAL = this.formatNumberWithThousands(item.CREDIT_BAL);
            item.LOAN_TERM = item.LOAN_SDT + " 至 " + item.LOAN_DDT;
          });

          // 主要授信往來小計
          this.credit_status.main_subTotal = Array.isArray(creditDetail.MAIN_SUBTOTAL) && creditDetail.MAIN_SUBTOTAL.length > 0 ? creditDetail.MAIN_SUBTOTAL[0] : null;
          if (this.credit_status.main_subTotal) {
            const main_subTotal = {
              CREDIT_ITEM: "小計",
              CONTRACT_AMOUNT: this.formatNumberWithThousands(this.credit_status.main_subTotal.SUM_CONTRACT_AMOUNT),
              CREDIT_BAL: this.formatNumberWithThousands(this.credit_status.main_subTotal.SUM_CREDIT_BAL),
              LOAN_TERM: `本案擔保比率： ${this.credit_status.main_subTotal.COLLATERAL_RATIO}%`,
              COLLATERAL: `貢獻度：${this.formatNumberWithThousands(this.credit_status.main_subTotal.PROF_CLIENT_PROF, true)}`,
              REMARKS: "",
            };
            this.credit_status.main.push(main_subTotal);
          }

          // 關係戶授信往來
          const childDetailData = Array.isArray(creditDetail.CHILD_DETAILDATA) ? creditDetail.CHILD_DETAILDATA : [];
          const arrayChildSubTotal = Array.isArray(creditDetail.CHILD_SUBTOTAL) ? creditDetail.CHILD_SUBTOTAL : [];
          arrayChildSubTotal.forEach((subItem) => {
            const child_subTotal = {
              CREDIT_ITEM: "小計",
              CONTRACT_AMOUNT: this.formatNumberWithThousands(subItem.SUM_CONTRACT_AMOUNT),
              CREDIT_BAL: this.formatNumberWithThousands(subItem.SUM_CREDIT_BAL),
              LOAN_TERM: `本案擔保比率： ${subItem.COLLATERAL_RATIO}%`,
              COLLATERAL: `貢獻度：${this.formatNumberWithThousands(subItem.PROF_CLIENT_PROF, true)}`,
              REMARKS: "",
            };
            let childItems = childDetailData.filter((item) => item.CHILD_CUSIDN === subItem.CHILD_CUSIDN);
            childDetailData.forEach((item) => {
              item.CONTRACT_AMOUNT = this.formatNumberWithThousands(item.CONTRACT_AMOUNT);
              item.CREDIT_BAL = this.formatNumberWithThousands(item.CREDIT_BAL);
              item.LOAN_TERM = item.LOAN_SDT + " 至 " + item.LOAN_DDT;
              item.CUS_NAME = item.CUS_NAME || "關係戶";
            });
            childItems.push(child_subTotal);
            this.credit_status.child.push(childItems);
          });

          if (creditDetail.ALL_SUBTOTAL) {
            this.credit_status.all_subTotal = Array.isArray(creditDetail.ALL_SUBTOTAL) ? creditDetail.ALL_SUBTOTAL : [];
            this.credit_status.all_subTotal[0].SUM_CREDIT_ITEM = "總計";
            this.credit_status.all_subTotal[0].SUM_CONTRACT_AMOUNT = this.formatNumberWithThousands(this.credit_status.all_subTotal[0].SUM_CONTRACT_AMOUNT);
            this.credit_status.all_subTotal[0].SUM_CREDIT_BAL = this.formatNumberWithThousands(this.credit_status.all_subTotal[0].SUM_CREDIT_BAL);
            this.credit_status.all_subTotal[0].SUM_LOAN_TERM = "本案擔保比率：" + this.credit_status.all_subTotal[0].COLLATERAL_RATIO + "%";
            this.credit_status.all_subTotal[0].SUM_COLLATERAL_RATIO = "貢獻度：" + this.formatNumberWithThousands(this.credit_status.all_subTotal[0].PROF_CLIENT_PROF, true);
          }

          this.showCompanyProfileNotice(response);
          this.comBriefVisible = true;
        } else {
          // 處理非 200/500 的錯誤邏輯
          console.error("取得公司詳細資料失敗", response.message || (response.data && response.data.message));
          this.comBriefVisible = false;
          notify({
            title: "錯誤",
            message: response.message || (response.data && response.data.message) || "無法取得公司概況資料",
            type: "error",
          });
        }
      } catch (error) {
        console.error("載入公司概況表資料失敗:", error);
        this.comBriefVisible = false;
        notify({ title: "錯誤", message: "查詢公司概況表失敗，請稍後再試", type: "error" });
      } finally {
        // this.$store.dispatch('loadingHandler', false);
      }
    },

    async loadBrandProdData(UniComNm) {
      console.log("載入商標資料...");
      // 全部載入, 不分頁, 並把重覆的Brand過濾掉
      const qry = {
        Page_Size: 100,
        Page_Num: 1,
        UniComNm: UniComNm,
        SortField: "DataDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_brand_prod(qry);
        // console.log('商標資料載入結果:', response);
        if (response && response.data) {
          // 針對 Brand 欄位進行分組，過濾重複的 Brand, 並過濾掉空白的 Brand 或"無"
          const brandMap = new Map();
          response.data.forEach((item) => {
            const brand = item.Brand;
            if (brand && brand !== "無" && !brandMap.has(brand)) {
              brandMap.set(brand, item);
            }
          });

          // 將 Map 轉換為陣列，並將原始數據轉換為 { label, value } 對的陣列
          const processedData = Array.from(brandMap.values()).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              // { label: "公司名稱", value: row.ComName },
              { label: "商標品牌", value: row.Brand },
              { label: "年度", value: row.ApvDt },
              // { label: "產業", value: row.IndusType },
              { label: "產品", value: row.MainProd },
              // { label: "資料日期", value: row.DataDt }
            ];
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[10].datasource = `${response.data[0]?.DataDt || ""}`;
          this.brand_prod_Query.brand_prod_List = processedData;
          this.brand_prod_Query.Total = parseInt(response.total) || processedData.length;
        }
      } catch (error) {
        console.error("載入商標資料失敗:", error);
      }
    },

    async loadParkNameData(UniComNm) {
      //console.log('載入所在園區資料...');

      const qry = {
        Page_Size: this.tech_park_Query.Page_Size,
        Page_Num: this.tech_park_Query.Page_Num,
        UniComNm: UniComNm,
        SortField: "DataDt",
        SortOrder: "desc",
      };

      try {
        const response = await this.$api.apidata.get_tech_park(qry);
        //console.log('所在園區資料載入結果:', response);
        if (response && response.data) {
          // 對每一行數據進行轉換，並移除空值項目
          const processedData = (response.data || []).map((row) => {
            // 將原始數據轉換為 { label, value } 對的陣列
            const itemsArray = [
              // { label: "統一編號", value: row.UniComNm },
              { label: "公司/工廠名稱", value: row.ComName },
              { label: "園區名稱", value: row.ParkName },
              { label: "所屬機關", value: row.AuthOrgan },
              { label: "地址", value: row.ComLoc },
              { label: "電話", value: row.PhoneNm },
              { label: "產業", value: row.IndusType },
              // { label: "資料來源", value: `經濟部產業園區管理局(${row.DataDt})` }
            ];
            return this.removeEmptyItems(itemsArray);
          });
          this.tabsList[11].datasource = `經濟部產業園區管理局`;
          this.tech_park_Query.park_name_List = processedData;
          this.tech_park_Query.Total = parseInt(response.total || 0);
        }
      } catch (error) {
        console.error("載入所在園區資料失敗:", error);
      }
    },

    async factoryDataListPageChange(val) {
      this.factoryDataListQuery.Page_Num = val;
      await this.loadFactoryDataList(this.unicomnm);
    },

    async apv_supply_PageChange(val) {
      this.apv_supply_Query.Page_Num = val;
      await this.loadApvSupplyData(this.unicomnm);
    },

    async com_invest_PageChange(val) {
      this.com_invest_Query.Page_Num = val;
      await this.loadComInvestData(this.unicomnm);
    },

    async com_invest_china_PageChange(val) {
      this.com_invest_china_Query.Page_Num = val;
      await this.loadComInvestChinaData(this.unicomnm);
    },

    async china_fund_PageChange(val) {
      this.china_fund_Query.Page_Num = val;
      await this.loadChinaFundData(this.unicomnm);
    },

    async pro_certify_PageChange(val) {
      this.pro_certify_Query.Page_Num = val;
      await this.loadProCertifyData(this.unicomnm);
    },

    async award_record_PageChange(val) {
      this.award_record_Query.Page_Num = val;
      await this.loadAwardRecordData(this.unicomnm);
    },

    async com_domain_PageChange(val) {
      this.com_domain_Query.Page_Num = val;
      await this.loadComDomainData(this.unicomnm);
    },

    async com_penalty_PageChange(val) {
      this.com_penalty_Query.Page_Num = val;
      await this.loadComPenaltyData(this.unicomnm);
    },

    async brand_prod_PageChange(val) {
      this.brand_prod_Query.Page_Num = val;
      await this.loadBrandProdData(this.unicomnm);
    },

    async tech_park_PageChange(val) {
      this.tech_park_Query.Page_Num = val;
      await this.loadParkNameData(this.unicomnm);
    },

    async exportBizExcel() {
      const exported = await exportCompanyOverviewExcel({
        comBriefVisible: this.comBriefVisible,
        basicInfo: this.basic_info,
        businessStatus: this.business_status,
        contribution: this.contribution,
        creditStatus: this.credit_status,
        fallbackCompanyName: this.FullComName || "公司",
      });

      if (exported) {
        const setAudit = {
          menu_path: ["潛在客戶智能搜尋", "企業標籤搜尋", "公司概況表"],
          action_type: "export",
          action_name: "匯出",
          details: {
            UniComNm: this.unicomnm,
            FullComName: this.FullComName,
            exported_pages: ["公司概況表(EXCEL)"],
          },
        };
        await this.$api.apimgrs.setAuditLog(setAudit);
      }
    },

    async exportBizPDF() {
      await exportCompanyOverviewPdf({
        api: this.$api,
        store: this.$store,
        comBriefVisible: this.comBriefVisible,
        basicInfo: this.basic_info,
        businessStatus: this.business_status,
        contribution: this.contribution,
        creditStatus: this.credit_status,
        fallbackCompanyName: this.FullComName || "公司",
      });
      // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為
      const setAudit = {
        menu_path: ["潛在客戶智能搜尋", "企業標籤搜尋", "公司概況表"],
        action_type: "export",
        action_name: "匯出",
        details: {
          UniComNm: this.unicomnm,
          FullComName: this.FullComName,
          exported_pages: ["公司概況表"],
        },
      };
      const resp = await this.$api.apimgrs.setAuditLog(setAudit);
    },

    async exportPDF() {
      if (!this.profileList || this.profileList.length === 0) {
        notify({ title: "錯誤", message: "目前無資料可匯出", type: "error" });
        return;
      }

      let auditPage = [];

      try {
        this.$store.dispatch("loadingHandler", true);

        const fontB64 = await loadPdfFontBase64();

        if (!fontB64) {
          notify({ title: "錯誤", message: `無法載入中文字型，請確認 /fonts/NotoSansTC-Regular.ttf 可存取且大小不超過${PDF_FONT_MAX_MB}MB`, type: "error" });
          this.$store.dispatch("loadingHandler", false);
          return;
        }

        const doc = new jsPDF("p", "mm", "a4");
        doc.addFileToVFS("NotoSansTC-Regular.ttf", fontB64);
        doc.addFont("NotoSansTC-Regular.ttf", "NotoSansTC", "normal");
        doc.addFont("NotoSansTC-Regular.ttf", "NotoSansTC", "bold");
        doc.setFont("NotoSansTC", "normal");

        // 取得浮水印（若有）
        let watermarkText = "機密資料";
        let watermarkImage = null; // data URI
        try {
          const wmRes = await this.$api.watermark.get_watermark({});
          if (wmRes) {
            if (wmRes.watermark) watermarkText = wmRes.watermark;
            else if (wmRes.data && wmRes.data.watermark) watermarkText = wmRes.data.watermark;
            if (wmRes.data && wmRes.data.image) watermarkImage = wmRes.data.image;
          }
        } catch (wmErr) {
          console.warn("取得浮水印失敗，使用預設值", wmErr);
        }

        // 0. 輸出稅籍頁
        await this._exportTaxPage(doc, watermarkText, watermarkImage);
        auditPage.push("稅籍頁");

        // 1. 輸出出進口資料
        if (this.tabsList[1].show) {
          doc.addPage();
          await this._exportIOPage(doc, watermarkText, watermarkImage);
          auditPage.push("出進口資料");
        }

        // 2. 輸出工廠資料
        if (this.tabsList[2].show) {
          doc.addPage();
          await this._exportFactoryPage(doc, watermarkText, watermarkImage);
          auditPage.push("工廠資料");
        }

        // 3. 輸出供應商資料
        if (this.tabsList[3].show) {
          doc.addPage();
          await this._exportApvSupplyPage(doc, watermarkText, watermarkImage);
          auditPage.push("供應商資料");
        }

        // 4. 輸出投資資料
        if (this.tabsList[4].show) {
          doc.addPage();
          await this._exportComInvestPage(doc, watermarkText, watermarkImage);
          auditPage.push("投資資料");
        }

        // 5. 輸出陸資來臺投資資料
        if (this.tabsList[5].show) {
          doc.addPage();
          await this._exportChinaFundPage(doc, watermarkText, watermarkImage);
          auditPage.push("陸資來臺投資資料");
        }

        // 6. 輸出赴中國大陸投資資料
        if (this.tabsList[6].show) {
          doc.addPage();
          await this._exportComInvestChinaPage(doc, watermarkText, watermarkImage);
          auditPage.push("赴中國大陸投資資料");
        }

        // 7. 輸出獲獎名稱資料
        if (this.tabsList[7].show) {
          doc.addPage();
          await this._exportAwardRecordPage(doc, watermarkText, watermarkImage);
          auditPage.push("獲獎名稱資料");
        }

        // 8. 輸出認證名稱資料
        if (this.tabsList[8].show) {
          doc.addPage();
          await this._exportProCertifyPage(doc, watermarkText, watermarkImage);
          auditPage.push("認證名稱資料");
        }

        // 9. 輸出領域名稱資料
        if (this.tabsList[9].show) {
          doc.addPage();
          await this._exportComDomainPage(doc, watermarkText, watermarkImage);
          auditPage.push("領域名稱資料");
        }

        // 10. 輸出商標資料
        if (this.tabsList[10].show) {
          doc.addPage();
          await this._exportBrandProdPage(doc, watermarkText, watermarkImage);
          auditPage.push("商標資料");
        }

        // 11. 輸出所在園區資料
        if (this.tabsList[11].show) {
          doc.addPage();
          await this._exportTechParkPage(doc, watermarkText, watermarkImage);
          auditPage.push("所在園區資料");
        }

        // 12. 輸出裁罰警示資料
        if (this.tabsList[12].show) {
          doc.addPage();
          await this._exportComPenaltyPage(doc, watermarkText, watermarkImage);
          auditPage.push("裁罰警示資料");
        }

        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[:-]/g, "")
          .replace("T", "_");
        const fileName = `${this.FullComName || "公司"}_基本資料_${timestamp}.pdf`;
        doc.save(fileName);

        notify({ title: "成功", message: `PDF 已匯出`, type: "success" });
      } catch (error) {
        console.error("exportPDF error", error);
        notify({ title: "錯誤", message: `PDF 匯出失敗：${error.message || "未知錯誤"}`, type: "error" });
      } finally {
        // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為
        const setAudit = {
          menu_path: ["潛在客戶智能搜尋", "企業標籤搜尋"],
          action_type: "export",
          action_name: "匯出",
          details: {
            UniComNm: this.unicomnm,
            FullComName: this.FullComName,
            exported_pages: auditPage,
          },
        };
        const resp = await this.$api.apimgrs.setAuditLog(setAudit);
        // console.log('稽核記錄結果', resp);

        this.$store.dispatch("loadingHandler", false);
      }
    },

    // 共用 HTML 文字濾除器
    stripHtml(html) {
      if (!html) return "";
      try {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
      } catch (e) {
        return html
          .replace(/<[^>]*>/g, "")
          .replace(/\s+/g, " ")
          .trim();
      }
    },

    // 匯出：稅籍資料
    async _exportTaxPage(doc, watermarkText, watermarkImage) {
      const companyName = this.FullComName || "";
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFontSize(16);
      doc.text(companyName.toString(), 14, 20);

      const headerX = 14;
      const headerY = 18; // 橫幅 Y
      const headerH = 0; // 橫幅高度

      const tableColumns = [
        { header: "項目", dataKey: "field" },
        { header: "內容", dataKey: "value" },
      ];

      const tableRows = this.profileList.map((item) => ({ field: item.title || "", value: item.isHtml ? this.stripHtml(item.htmlValue || item.value || "") : item.value || "" }));

      const startY = headerY + headerH + 8;

      autoTable(doc, {
        columns: tableColumns,
        head: [tableColumns.map((c) => c.header)],
        showHead: "everyPage",
        body: tableRows,
        startY,
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          this.decoratePdfPage(doc, watermarkText, watermarkImage, "稅藉資料共 1 筆資料");
        },
      });
    },

    // 匯出：認證名稱資料
    async _exportProCertifyPage(doc, watermarkText, watermarkImage) {
      // 先載入認證名稱資料
      this.pro_certify_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadProCertifyData(this.unicomnm);
      this.pro_certify_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.pro_certify_Query && this.pro_certify_Query.pro_certify_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無認證資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `認證名稱共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("認證名稱資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      // autoTable(doc, {
      //     columns: [
      //         { header: '項目', dataKey: 'field' },
      //         { header: '內容', dataKey: 'value' }
      //     ],
      //     body: [
      //         { field: '資料日期', value: this.tabsList[8].datasource }
      //     ],
      //     startY: currentY,
      //     showHead: 'never',
      //     styles: { font: 'NotoSansTC', fontSize: 10, cellPadding: 2, valign: 'middle' },
      //     headStyles: { font: 'NotoSansTC', fontStyle: 'bold', fillColor: [255, 246, 239], textColor: 60 },
      //     columnStyles: { 0: { cellWidth: 50 } },
      //     margin: { left: 14, right: 14, bottom: 20 },
      //     didDrawPage: () => {
      //         drawWatermarkAndFooter(list.length);
      //     }
      // });
    },

    // 匯出：工廠資料
    async _exportFactoryPage(doc, watermarkText, watermarkImage) {
      // 先載入工廠資料
      this.factoryDataListQuery.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadFactoryDataList(this.unicomnm);
      this.factoryDataListQuery.Page_Size = 10; // 還原分頁大小
      const list = this.factoryDataListQuery.factory_Data_List || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無工廠資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "title" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `工廠登記資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("工廠資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[2].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：獲獎資訊
    async _exportAwardRecordPage(doc, watermarkText, watermarkImage) {
      // 先載入獲獎資料
      this.award_record_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadAwardRecordData(this.unicomnm);
      this.award_record_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.award_record_Query && this.award_record_Query.award_record_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無獲獎資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `獲獎資訊共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("獲獎資訊", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）

      // autoTable(doc, {
      //     columns: [
      //         { header: '項目', dataKey: 'field' },
      //         { header: '內容', dataKey: 'value' }
      //     ],
      //     body: [
      //         { field: '資料日期', value: this.tabsList[7].datasource }
      //     ],
      //     startY: currentY,
      //     showHead: 'never',
      //     styles: { font: 'NotoSansTC', fontSize: 10, cellPadding: 2, valign: 'middle' },
      //     headStyles: { font: 'NotoSansTC', fontStyle: 'bold', fillColor: [255, 246, 239], textColor: 60 },
      //     columnStyles: { 0: { cellWidth: 50 } },
      //     margin: { left: 14, right: 14, bottom: 20 },
      //     didDrawPage: () => {
      //         drawWatermarkAndFooter(list.length);
      //     }
      // });
    },

    // 匯出：領域名稱資料
    async _exportComDomainPage(doc, watermarkText, watermarkImage) {
      // 先載入領域名稱資料
      this.com_domain_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadComDomainData(this.unicomnm);
      this.com_domain_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.com_domain_Query && this.com_domain_Query.com_domain_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無領域資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `領域名稱共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("領域名稱資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      // autoTable(doc, {
      //     columns: [
      //         { header: '項目', dataKey: 'field' },
      //         { header: '內容', dataKey: 'value' }
      //     ],
      //     body: [
      //         { field: '資料日期', value: this.tabsList[9].datasource }
      //     ],
      //     startY: currentY,
      //     showHead: 'never',
      //     styles: { font: 'NotoSansTC', fontSize: 10, cellPadding: 2, valign: 'middle' },
      //     headStyles: { font: 'NotoSansTC', fontStyle: 'bold', fillColor: [255, 246, 239], textColor: 60 },
      //     columnStyles: { 0: { cellWidth: 50 } },
      //     margin: { left: 14, right: 14, bottom: 20 },
      //     didDrawPage: () => {
      //         drawWatermarkAndFooter(list.length);
      //     }
      // });
    },

    // 匯出：裁罰警示資料
    async _exportComPenaltyPage(doc, watermarkText, watermarkImage) {
      // 先載入裁罰資料
      this.com_penalty_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadComPenaltyData(this.unicomnm);
      this.com_penalty_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.com_penalty_Query && this.com_penalty_Query.com_penalty_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無裁罰資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `裁罰警示資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("裁罰警示資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[12].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：陸資來台投資資料
    async _exportChinaFundPage(doc, watermarkText, watermarkImage) {
      // 先載入陸資來台資料
      this.china_fund_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadChinaFundData(this.unicomnm);
      this.china_fund_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.china_fund_Query && this.china_fund_Query.china_fund_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無陸資來台資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `陸資來台投資資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("陸資來台投資資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[5].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：供應商 / 生產廠場資料
    async _exportApvSupplyPage(doc, watermarkText, watermarkImage) {
      // 先載入供應商資料
      this.apv_supply_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadApvSupplyData(this.unicomnm);
      this.apv_supply_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.apv_supply_Query && this.apv_supply_Query.apv_supply_List) || [];

      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無生產廠場資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `供應商 / 生產廠場資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("生產廠場資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[3].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：出進口資料
    async _exportIOPage(doc, watermarkText, watermarkImage) {
      // 確保出進口資料已載入
      await this.loadIoDataList(this.unicomnm, "", { expandDetails: true });
      if (!this.ioDataList || this.ioDataList.length === 0) {
        notify({ title: "錯誤", message: "目前無出進口資料可匯出", type: "error" });
        return;
      }
      // console.log('匯出前 ioDataList', this.ioDataList);
      doc.setFontSize(16);
      doc.text("出進口資料", 14, 20);

      const headerX = 14;
      const headerY = 18;
      const headerH = 0;

      const tableColumns = [
        { header: "項目", dataKey: "field" },
        { header: "內容", dataKey: "value" },
      ];

      const tableRows = (this.ioDataList || []).map((item) => ({ field: item.title || "", value: item.isHtml ? this.stripHtml(item.htmlValue || item.value || "") : item.value || "" }));

      const startY = headerY + headerH + 8;

      autoTable(doc, {
        columns: tableColumns,
        body: tableRows,
        startY,
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          this.decoratePdfPage(doc, watermarkText, watermarkImage, "出進口資料共 1 筆資料");
        },
      });
    },

    // 匯出：投資資料
    async _exportComInvestPage(doc, watermarkText, watermarkImage) {
      // 先載入投資資料
      this.com_invest_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadComInvestData(this.unicomnm);
      this.com_invest_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.com_invest_Query && this.com_invest_Query.com_invest_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無對外投資資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `對外投資資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("對外投資資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[4].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：赴大陸投資資料
    async _exportComInvestChinaPage(doc, watermarkText, watermarkImage) {
      // 先載入赴大陸投資資料
      this.com_invest_china_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadComInvestChinaData(this.unicomnm);
      this.com_invest_china_Query.Page_Size = 10; // 還原分頁大小
      const list = (this.com_invest_china_Query && this.com_invest_china_Query.com_invest_china_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無赴大陸投資資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `赴大陸投資資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("赴大陸投資資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });
      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[6].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 匯出：科技園區資料
    async _exportTechParkPage(doc, watermarkText, watermarkImage) {
      // 先載入園區資料
      this.tech_park_Query.Page_Size = 255; // 一次載入所有資料以便匯出
      await this.loadParkNameData(this.unicomnm);
      this.tech_park_Query.Page_Size = 10;
      const list = (this.tech_park_Query && this.tech_park_Query.park_name_List) || [];
      if (!list || list.length === 0) {
        notify({ title: "提示", message: "無園區資料可匯出", type: "info" });
        return;
      }

      const tableColumns = [
        { header: "項目", dataKey: "label" },
        { header: "內容", dataKey: "value" },
      ];

      const drawWatermarkAndFooter = (totalCount) => {
        this.decoratePdfPage(doc, watermarkText, watermarkImage, `科技園區資料共 ${totalCount} 筆資料`);
      };

      // 第一頁標題
      doc.setFontSize(16);
      doc.text("所在園區資料", 14, 20);
      let currentY = 30;

      // 每筆資料各自輸出一個表格
      list.forEach((item, index) => {
        // 輸出索引信息
        doc.setFontSize(10);
        doc.text(`第 ${index + 1} 筆 / 共 ${list.length} 筆`, 14, currentY);
        currentY += 8;

        autoTable(doc, {
          columns: tableColumns,
          head: [tableColumns.map((c) => c.header)],
          showHead: "everyPage",
          body: item,
          startY: currentY,
          styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
          headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
          columnStyles: { 0: { cellWidth: 50 } },
          margin: { left: 14, right: 14, bottom: 20 },
          didDrawPage: () => {
            drawWatermarkAndFooter(list.length);
          },
        });

        // 記錄這個表格結束的 Y 位置，下一個表格在此之後加一些空行
        currentY = doc.lastAutoTable.finalY + 10;
      });

      // 新增一行資料來源（只輸出body，不含標題列）
      autoTable(doc, {
        columns: [
          { header: "項目", dataKey: "field" },
          { header: "內容", dataKey: "value" },
        ],
        body: [{ field: "資料來源", value: this.tabsList[11].datasource }],
        startY: currentY,
        showHead: "never",
        styles: { font: "NotoSansTC", fontSize: 10, cellPadding: 2, valign: "middle" },
        headStyles: { font: "NotoSansTC", fontStyle: "bold", fillColor: [255, 246, 239], textColor: 60 },
        columnStyles: { 0: { cellWidth: 50 } },
        margin: { left: 14, right: 14, bottom: 20 },
        didDrawPage: () => {
          drawWatermarkAndFooter(list.length);
        },
      });
    },

    // 處理標籤點擊事件
    handleTagClick(tagStr, tagCategory, tagType = "標準標籤") {
      // 記錄點擊Tag
      this.$queryRecord(this, tagStr, "tag", tagType);
      //console.log(`點擊了${tagType} - ${tagCategory}：`, tagStr);

      const forceTablet = (process.env.VUE_APP_FORCE_TABLET || "").toLowerCase() === "true";
      if (isTabletDevice() || forceTablet) {
        // 平板裝置內部導航
        // this.$router.push({ path: '/ctm', query: { keyword: tagStr, category: tagCategory, type: tagType } });
        const routeData = this.$router.resolve({
          name: "m-ctm",
          query: { keyword: tagStr, category: tagCategory, type: tagType },
        });
        window.open(routeData.href, "_blank");
      } else {
        // 開啟新視窗
        const baseUrl = window.location.origin;
        window.open(`${baseUrl}/ctm?keyword=${tagStr}&category=${tagCategory}&type=${tagType}`, "_blank");
      }
    },

    handleSameAddressClick(encodedAddress) {
      let address = "";
      try {
        address = decodeURIComponent(encodedAddress || "");
      } catch (e) {
        address = encodedAddress || "";
      }
      if (!address) return;

      const forceTablet = (process.env.VUE_APP_FORCE_TABLET || "").toLowerCase() === "true";
      if (isTabletDevice() || forceTablet) {
        const routeData = this.$router.resolve({
          name: "m-ctm",
          query: { comloc: address },
        });
        window.open(routeData.href, "_blank");
      } else {
        const baseUrl = window.location.origin;
        window.open(`${baseUrl}/ctm?comloc=${encodeURIComponent(address)}`, "_blank");
      }
    },

    btnOpDetail(type, row) {
      let showDetailDrawer = false;
      switch (type) {
        case "工廠":
          this.detailDrawerTitle = "工廠明細";
          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "工廠名稱", value: row.FtyName },
            { label: "工廠登記編號", value: row.FtyRegNm },
            { label: "工廠設立許可案號", value: row.FtyApvNm },
            { label: "工廠地址", value: row.FtyLoc },
            { label: "工廠市鎮鄉村里", value: row.FtyLocVillage },
            { label: "負責人姓名", value: row.RepName },
            { label: "工廠組織型態", value: row.FtyType },
            { label: "工廠設立核准日期", value: row.FtyApvDt },
            { label: "工廠登記核准日期", value: row.FtyRegDt },
            { label: "工廠登記狀態", value: row.FtyRegStatus },
            { label: "產業類別", value: row.IndusType },
            { label: "主要產品", value: row.MainProd },
            { label: "資料來源", value: "經濟部產業發展署(" + row.DataDt + ")" },
          ];
          showDetailDrawer = true;
          break;

        case "供應商":
          this.$notify({
            title: "提示",
            message: "供應商明細功能尚未實作",
            type: "info",
            duration: 2000,
          });
          break;

        case "投資":
          // console.log("對外投資明細", row);
          this.detailDrawerTitle = "對外投資明細";
          // 國別,業別,對外投資事業名稱(中文),對外投資事業名稱(英文),國外電話,國外傳真,對外事業地址,國內投資人,國內負責人,國內電話,國內傳真,國內地址,統一編號,主要營業項目,核准記錄,核准日期、資料日期
          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "國別", value: row.Nation },
            { label: "業別", value: row.IndusType },
            { label: "對外投資事業名稱(中文)", value: row.ComName },
            { label: "對外投資事業名稱(英文)", value: row.ForEngComName },
            { label: "國外電話", value: row.ForComPhone },
            { label: "國外傳真", value: row.ForComFax },
            { label: "對外事業地址", value: row.ForComLoc },
            { label: "國內投資人", value: row.RepName },
            { label: "國內負責人", value: row.RepName },
            { label: "國內電話", value: row.PhoneNm },
            { label: "國內傳真", value: row.FaxNm },
            { label: "國內地址", value: row.ComLoc },
            { label: "核准記錄", value: row.ApvRecord },
            { label: "核准日期", value: row.ApvDt },
            { label: "主要營業項目", value: row.MainProd },
            { label: "資料來源", value: "經濟部(" + row.DataDt + ")" },
          ];
          showDetailDrawer = true;
          break;

        case "陸資":
          // console.log("陸資投資明細", row);
          this.detailDrawerTitle = "陸資投資明細";
          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "陸資投資人名稱", value: row.ChinaComName },
            { label: "核准月年", value: row.ApvDt },
            { label: "投資型態", value: row.InvestType },
            { label: "國內被投資事業名稱", value: row.ComName },
            { label: "國內被投資事業登記地址", value: row.ComLoc },
            { label: "投資金額（新台幣）", value: row.InvestCap },
            { label: "行業分類", value: row.IndusType },
            { label: "備註", value: row.Memo },
            { label: "資料日期", value: row.DataDt },
          ];
          showDetailDrawer = true;
          break;

        case "赴大陸":
          this.detailDrawerTitle = "赴大陸投資明細";
          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "國內投資人", value: row.ComName },
            { label: "核准日期", value: row.ApvDt },
            { label: "大陸投資事業", value: row.ChinaComName },
            { label: "大陸事業地址", value: row.ChinaComLoc },
            { label: "大陸業別", value: row.IndusType },
            { label: "資料日期", value: row.DataDt },
          ];
          showDetailDrawer = true;
          break;

        case "商標":
          this.$notify({
            title: "提示",
            message: "商標明細功能尚未實作",
            type: "info",
            duration: 2000,
          });
          break;

        case "園區":
          this.$notify({
            title: "提示",
            message: "園區明細功能尚未實作",
            type: "info",
            duration: 2000,
          });
          break;

        case "裁罰":
          this.$notify({
            title: "提示",
            message: "裁罰明細功能尚未實作",
            type: "info",
            duration: 2000,
          });
          break;

        case "獲獎":
          this.drawerTitle = "獲獎明細";
          // console.log("獲獎明細", row);
          // 統一編號、公司名稱、地址、負責人/申請人、職稱、電話、行動電話、聯絡信箱、獲獎名稱、日期(起) 、日期(迄) 、產業、產品、備註、資料日期
          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "公司名稱", value: row.ComName },
            { label: "地址", value: row.ComLoc },
            { label: "負責人/申請人", value: row.RepName },
            { label: "職稱", value: row.Title },
            { label: "電話", value: row.PhoneNm },
            { label: "行動電話", value: row.MobileNm },
            { label: "聯絡信箱", value: row.ComEmail },
            { label: "獲獎名稱", value: row.AwardName },
            { label: "日期(起)", value: row.StartDt },
            { label: "日期(迄)", value: row.EndDt },
            { label: "產業", value: row.IndusType },
            { label: "產品", value: row.MainProd },
            { label: "備註", value: row.Memo },
            { label: "資料日期", value: row.DataDt },
          ];
          showDetailDrawer = true;
          break;

        case "認證":
          this.drawerTitle = "認證明細";
          // console.log("認證明細", row);
          this.drawerDataDetail = [
            { label: "統一編號/工廠登記編號", value: row.UniComNm },
            { label: "公司名稱", value: row.ComName },
            { label: "地址", value: row.ComLoc },
            { label: "負責人", value: row.RepName },
            { label: "電話", value: row.PhoneNm },
            { label: "認證名稱", value: row.CertifyName },
            { label: "日期(起)", value: row.StartDt },
            { label: "日期(迄)", value: row.EndDt },
            { label: "產業", value: row.IndusType },
            { label: "產品", value: row.MainProd },
            { label: "資料日期", value: row.DataDt },
          ];
          showDetailDrawer = true;
          break;

        case "領域":
          this.drawerTitle = "領域明細";
          //console.log("領域明細", row);

          this.drawerDataDetail = [
            { label: "統一編號", value: row.UniComNm },
            { label: "公司名稱", value: row.ComName },
            { label: "地址", value: row.ComLoc },
            { label: "負責人", value: row.RepName },
            { label: "經理人/店長/聯絡人", value: row.MgrName },
            { label: "經理人/店長職稱", value: row.MgrTitle },
            { label: "電話", value: row.PhoneNm },
            { label: "聯絡信箱", value: row.ComEmail },
            { label: "領域名稱", value: row.DomainName },
            { label: "所屬集團", value: row.GroupName },
            { label: "日期(起)", value: row.StartDt },
            { label: "日期(迄)", value: row.EndDt },
            { label: "產業", value: row.IndusType },
            { label: "產品", value: row.MainProd },
            { label: "備註", value: row.Memo },
            { label: "資料日期", value: row.DataDt },
          ];
          showDetailDrawer = true;
          break;

        default:
          alert("未知的明細類型: " + type);
          break;
      }

      this.detailDrawerVisible = showDetailDrawer;
    },

    // 稅籍日期改變
    handleDateChange(value) {
      this.selectedDate = value;
      // 針對nationTaxList 重新過濾出選擇日期的資料
      //console.log("nationTaxList", this.nationTaxList);
      const updateNationTax = this.nationTaxList.filter((x) => x.DataDt == this.selectedDate);
      if (updateNationTax.length > 0) {
        const detail = updateNationTax[0];
        // console.log("異動日期", value, detail);
        // 利用detail 資料, 重新更新profileList
        // 取出每一個detail欄位, 轉成profileList格式
        let fields = [
          { key: "ComLoc", title: "營業地址" },
          { key: "HQUniComNm", title: "總機構統一編號" },
          { key: "UniComNm", title: "統一編號" },
          { key: "ComName", title: "營業人名稱" },
          { key: "Cap", title: "資本額" },
          { key: "ApvDt", title: "設立日期" },
          { key: "ComType", title: "組織別名稱" },
          { key: "Voice", title: "使用發票" },
          { key: "IndusType", title: "行業名稱" },
          { key: "IndusNm", title: "行業代號" },
          { key: "DataSource", title: "資料來源" },
        ];

        const indusTypes = [detail.IndusType, detail.IndusType1, detail.IndusType2, detail.IndusType3].filter((type) => type && type !== null && type !== "").join(" / ");

        const indusNms = [detail.IndusNm, detail.IndusNm1, detail.IndusNm2, detail.IndusNm3].filter((nm) => nm && nm !== null && nm !== "").join(" / ");

        const result = {
          ...detail,
          fulladdress: detail.ComLoc,
          IndusType: indusTypes,
          IndusNm: indusNms,
          DataSource: "財政部財政資訊中心(" + this.dataSelectedDate + ")",
        };

        // console.log("處理後的資料", result);

        // console.log("要更新的欄位", result['Cap'], this.profileList.find(item => item.title === "資本額")?.value);

        // 把this.profileList裡面對應title的value更新成result裡面的值
        for (let item of this.profileList) {
          // 找出 fileds 中的key對應item.title的欄位
          const field = fields.find((f) => f.title === item.title);
          if (field) {
            if (item.value != result[field.key]) {
              // console.log("檢查欄位", item.title, "目前值", item.value, "更新值", result[field.key]);
              console.log("更新欄位");
            }
            if (result[field.key]) {
              // console.log("更新欄位", item.title, "從", item.value, "到", result[field.key]);
              if (item.title == "資本額") {
                // 資本額需要加上千分位逗號
                result[field.key] = parseInt(result[field.key]).toLocaleString();
              }
              item.value = result[field.key];
            }
          }
        }

        // for(let field of fields) {
        //     if(result[field.key]?.length) {
        //         // 取代現有 相同title的欄位
        //         let existingIndex = this.profileList.findIndex(item => item.title === field.title);
        //         if( field.key =="Cap") {
        //             console.log("原來資本額", this.profileList[existingIndex].value);
        //             console.log("新的資本額", result[field.key]);
        //         }
        //         if(existingIndex !== -1 && this.profileList[existingIndex].value != result[field.key]) {
        //             console.log("更新欄位", field.title, "從", this.profileList[existingIndex].value, "到", result[field.key]);
        //             this.profileList[existingIndex].value = result[field.key];
        //         } else if (existingIndex === -1) {
        //             console.log("新增欄位", field.title, result[field.key]);
        //             this.profileList.push({title: field.title, value: result[field.key]});
        //         }
        //         // this.profileList.push({title: field.title, value: result[field.key]});
        //     }
        // }
      } else {
        alert("所選日期無資料");
      }

      // console.log("selectedDate",this.selectedDate);
    },

    // 工廠登記異動日期改變
    handleFactoryDateChange(value) {
      this.factoryDataSelectedDate = value;
      // 針對factoryDataTotalList 重新過濾出選擇日期的資料
      const updateFactoryData = this.factoryDataTotalList.filter((x) => x.DataDt == this.factoryDataSelectedDate);
      if (updateFactoryData.length > 0) {
        this.factoryDataList = updateFactoryData;
        this.factoryDataListTotals = this.factoryDataList.length;
        // console.log("工廠異動日期", value, this.factoryDataList);
      }
    },

    async loadFactoryDataList(unicomnm) {
      this.$store.dispatch("loadingHandler", true);
      try {
        const qry = {
          Page_Size: this.factoryDataListQuery.Page_Size,
          Page_Num: this.factoryDataListQuery.Page_Num,
          UniComNm: unicomnm,
          IsLatest: "Y",
          SortField: "FtyRegDt",
          SortOrder: "desc",
        };
        const res = await this.$api.apidata.get_regftylist(qry);

        // 對每一行數據進行轉換，並移除空值項目
        const processedData = (res.data || []).map((row) => {
          // 將原始數據轉換為 { title, value } 對的陣列
          const itemsArray = [
            // { title: "統一編號", value: row.UniComNm },
            { title: "工廠名稱", value: row.FtyName },
            { title: "工廠登記編號", value: row.FtyRegNm },
            // { title: "工廠設立許可案號", value: row.FtyApvNm },
            { title: "工廠地址", value: row.FtyLoc },
            { title: "工廠市鎮鄉村里", value: row.FtyLocVillage },
            { title: "負責人姓名", value: row.RepName },
            // { title: "工廠組織型態", value: row.FtyType },
            { title: "工廠設立核准日期", value: row.FtyApvDt },
            { title: "工廠登記核准日期", value: row.FtyRegDt },
            { title: "工廠登記狀態", value: row.FtyRegStatus },
            { title: "產業類別", value: row.IndusType },
            { title: "主要產品", value: row.MainProd },
            // { title: "資料來源", value: `經濟部產業發展署(${row.DataDt})` }
          ];

          // 移除空值項目，並返回處理後的項目陣列
          return this.removeEmptyItems(itemsArray);
        });
        this.tabsList[2].datasource = `經濟部產業發展署`;
        this.factoryDataListQuery.factory_Data_List = processedData;
        this.factoryDataListQuery.Total = parseInt(res.total) || 0;
      } catch (err) {
        handleError(err, {
          title: "錯誤",
          message: "查詢失敗，請稍後再試",
          type: "error",
        });
      }
      this.$store.dispatch("loadingHandler", false);
    },

    resolveIoDataMappingValue(rankKey) {
      const matchedEntry = (this.ioDataMapping || []).find((entry) => entry && entry.key === rankKey);
      return matchedEntry ? matchedEntry.value || rankKey : rankKey;
    },

    showDrawer(type) {
      // 設定抓屉標題
      this.drawerTitle = type === "import" ? "進口實績" : "出口實績";
      this.drawerColumnLabel = type === "import" ? "總進口實績" : "總出口實績";
      // console.log("raw data companyDetail:", this.companyDetail);
      // 直接從 companyDetail 取得原始資料（避免依賴尚未載入的 profileList）
      const raw = type === "import" ? this.companyDetail.au_import_value : this.companyDetail.au_export_value;

      // console.log("raw data for drawer:", raw);

      // 正規化：支援陣列、逗號分隔字串或 JSON 字串
      let list = [];
      if (Array.isArray(raw)) {
        list = raw;
        // 使用 map（不是 foreach）產生表格資料
        this.drawerData = list
          .sort((a, b) => {
            // 按照 event_date 降序排列
            return new Date(b.event_date) - new Date(a.event_date);
          })
          .map((item) => {
            const rankKey = item.name || "";
            return {
              date: item.event_date || "",
              rank: this.resolveIoDataMappingValue(rankKey),
            };
          });
      }

      // 顯示抓屉
      this.drawerVisible = true;
    },

    async loadIoDataList(unicomnm, selectedDate = "", options = {}) {
      this.$store.dispatch("loadingHandler", true);
      try {
        const { expandDetails = false } = options;

        const qry = {
          Page_Size: 25,
          Page_Num: 1,
          SearchText: unicomnm,
          // "IsLatest": isLatest
        };
        this.ioDataList = [];

        //console.log("ioDataDetail",qry);
        await this.$api.apidata
          .get_com_trade(qry)
          .then((res) => {
            // 看有幾筆資料, 代表有多筆歷史資料, 取出Distinct DataDt 給使用者選擇, ioDataHistoryList
            this.ioDataHistoryList = [...new Set(res.data.map((item) => item.DataDt))];

            let ioTableData = [];
            if (selectedDate != "") {
              // 有選擇日期, 取出該日期的資料
              ioTableData = res.data.filter((x) => x.DataDt == selectedDate);
            } else {
              // 沒有選擇日期, 取最新的資料, IsLatest=="Y"
              ioTableData = res.data.filter((x) => x.IsLatest == "Y");
            }

            // console.log("出進口資料",ioTableData);
            this.ioDataSelectedDate = ioTableData.length > 0 ? ioTableData[0].DataDt : "";
            // this.totalLists = parseInt(res.hits.total.value);
            // 統一編號	原始登記日期	核發日期	廠商中文名稱	廠商英文名稱	中文營業地址	英文營業地址	代表人	電話號碼	傳真號碼	進口資格	出口資格
            // "ie_UniCode","ie_OrigRegDate","ie_ApprovedDate","ie_ChnName","ie_EngName","ie_ChnAddr","ie_EngAddr","ie_RepName","ie_Tel","ie_Fax","ie_Import","ie_Export"
            // console.log("ioTableData", ioTableData);
            // console.log("companyDetail", this.companyDetail);
            if (ioTableData.length > 0) {
              var ret = ioTableData[0];
              this.ioDataList = [];
              // this.ioDataList.push({title:"統一編號", value: ret.UniComNm });
              this.ioDataList.push({ title: "原始登記日期", value: ret.OrigRegDt });
              this.ioDataList.push({ title: "核發日期", value: ret.ApvDt });
              // this.ioDataList.push({title:"廠商中文名稱", value: ret.ComName });
              this.ioDataList.push({ title: "廠商英文名稱", value: ret.ForEngComName });
              this.ioDataList.push({ title: "中文營業地址", value: ret.ComLoc });
              this.ioDataList.push({ title: "英文營業地址", value: ret.ENComLoc });
              this.ioDataList.push({ title: "代表人", value: ret.RepName });
              this.ioDataList.push({ title: "電話號碼", value: ret.PhoneNm });
              this.ioDataList.push({ title: "傳真號碼", value: ret.FaxNm });
              //console.log("進出口資格", ret.IsImport, ret.IsExport);
              // this.ioDataList.push({title:"進口資格", value: ret.IsImport });
              // this.ioDataList.push({title:"出口資格", value: ret.IsExport });
              if (ret.IsImport == "有") {
                // 有進口資格時只保留點擊入口，實績內容交由右側 drawer 顯示
                this.ioDataList.push({ title: "進口資格", value: ret.IsImport + "(點擊查看實績)", clickable: true, linkType: "import" });
                if (expandDetails) {
                  const formatImportValue = (this.companyDetail.au_import_value || [])
                    .slice()
                    .sort((a, b) => (b.event_date || "").localeCompare(a.event_date || ""))
                    .map((item) => {
                      const year = item.event_date ? item.event_date.substring(0, 4) : "";
                      return { title: `進口實績 ${year}年`, value: this.resolveIoDataMappingValue(item.name || "") };
                    });
                  this.ioDataList.push(...formatImportValue);
                }
              } else {
                this.ioDataList.push({ title: "進口資格", value: "無" });
              }

              if (ret.IsExport == "有") {
                this.ioDataList.push({ title: "出口資格", value: ret.IsExport + "(點擊查看實績)", clickable: true, linkType: "export" });
                if (expandDetails) {
                  const formatExportValue = (this.companyDetail.au_export_value || [])
                    .slice()
                    .sort((a, b) => (b.event_date || "").localeCompare(a.event_date || ""))
                    .map((item) => {
                      const year = item.event_date ? item.event_date.substring(0, 4) : "";
                      return { title: `出口實績 ${year}年`, value: this.resolveIoDataMappingValue(item.name || "") };
                    });
                  this.ioDataList.push(...formatExportValue);
                }
              } else {
                this.ioDataList.push({ title: "出口資格", value: "無" });
              }
              this.ioDataList.push({ title: "資料來源", value: "經濟部國際貿易署(" + ret.DataDt + ")" });
              // 移除 value 為空的項目
              this.ioDataList = this.removeEmptyItems(this.ioDataList);
            }
          })
          .catch((err) => {
            handleError(err, {
              title: "錯誤",
              message: "查詢失敗，請稍後再試",
              type: "error",
            });
          });
      } catch (err) {
        handleError(err, {
          title: "錯誤",
          message: "查詢失敗，請稍後再試",
          type: "error",
        });
      }
      this.$store.dispatch("loadingHandler", false);
    },

    handleTag(tag) {
      alert(tag);
      // 對外投資, 陸資來臺投資, 赴中國大陸投資,獲獎名稱, 認證名稱,  領域名稱, 所在園區, 裁罰警示
      if (tag == "對外投資") {
        this.keyword = "對外投資";
      } else if (tag == "陸資來臺投資") {
        this.keyword = "陸資來臺投資";
      } else if (tag == "赴中國大陸投資") {
        this.keyword = "赴中國大陸投資";
      } else if (tag == "獲獎名稱") {
        this.keyword = "獲獎名稱";
      } else if (tag == "認證名稱") {
        this.keyword = "認證名稱";
      } else if (tag == "領域名稱") {
        this.keyword = "領域名稱";
      } else if (tag == "所在園區") {
        this.keyword = "所在園區";
      } else if (tag == "裁罰警示") {
        this.keyword = "裁罰警示";
      } else {
        this.keyword = "台企銀";
      }
    },

    doSearch() {
      console.log("doSearch", this.keyword);
    },

    // methods
    leafletMap() {
      var locations = [
        [this.latitude, this.longitude],
        // 更多座標...
      ];

      // this.mapCom = L.map('map',{ attributionControl: false}).setView([this.latitude, this.longitude], this.zoomDegree);

      //var map = L.map('map',{ attributionControl: false}).setView([24.9895, 121.5080], 16);

      // var greenIcon = new L.Icon({
      //     iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
      //     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      //     iconSize: [25, 41],
      //     iconAnchor: [12, 41],
      //     popupAnchor: [1, -34],
      //     shadowSize: [41, 41]
      // });

      var orangeIcon = new L.Icon({
        iconUrl: "/markericons/marker-icon-2x-orange.png",
        shadowUrl: "/markericons/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      // 為每個座標創建一個標記
      // for (var i = 0; i < locations.length; i++) {
      //     L.marker(locations[i], {icon: greenIcon}).addTo(map);
      // }

      // 為每個座標創建一個標記
      let conmame = this.$route.query.branch;
      const ctx = "<h3>" + conmame + "</h3>";
      for (var i = 0; i < locations.length; i++) {
        L.marker(locations[i], { icon: orangeIcon })
          .addTo(this.mapCom)
          .bindPopup(ctx)
          .openPopup();
      }

      L.tileLayer(process.env.VUE_APP_TILE_LAYER_URL + "/data/v3/{z}/{x}/{y}.jpg", {
        minZoom: 10,
        maxZoom: 16,
        attribution: "",
      }).addTo(this.mapCom);
    },

    async groupMap() {
      var orangeIcon = new L.Icon({
        iconUrl: "/markericons/marker-icon-2x-orange.png",
        shadowUrl: "/markericons/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      // this.mapObj.remove();
      console.log(this.zoomDegree);

      this.mapObj = L.map("map", { attributionControl: false }).setView([this.latitude, this.longitude], this.zoomDegree);

      L.tileLayer(process.env.VUE_APP_TILE_LAYER_URL + "/data/v3/{z}/{x}/{y}.jpg", {
        minZoom: 10,
        maxZoom: 16,
        attribution: "",
      }).addTo(this.mapObj);

      var markers = new L.markerClusterGroup().addTo(this.mapObj);

      // console.log(this.tabledata);

      // 為POI座標創建一個標記
      console.log("公司座標", this.companyDetail);
      var lat = this.companyDetail.Latitude;
      var lng = this.companyDetail.Longitude;
      var companyName = this.companyDetail.ComName || this.companyDetail.Branch || this.FullComName || "";
      var location = this.companyDetail.ComLoc;
      var popMessage = "<h1>" + companyName + "</h1><p>地址：" + location + "</p>";
      markers.addLayer(L.marker([lat, lng], { icon: orangeIcon }).bindPopup(popMessage));

      // 尤於地圖載入時, 會發生地圖無法顯示的問題, 所以延遲100ms後再請求地圖重繪
      setTimeout(() => {
        this.mapObj.invalidateSize();
      }, 100);
    },

    async showMap() {
      {
        this.$store.dispatch("loadingHandler", true);
        if (this.companyDetail) {
          this.latitude = this.companyDetail.Latitude;
          this.longitude = this.companyDetail.Longitude;
          this.zoomDegree = 16;
          // 產生地圖
          await this.groupMap();
        }
        this.$store.dispatch("loadingHandler", false);
      }
    },

    async refreshMap() {
      console.log("refreshMap");
      this.mapCom.eachLayer((layer) => {
        this.mapCom.removeLayer(layer);
        this.mapCom.addLayer(layer);
      });
    },

    async getCompanyDetail(unicomnm) {
      this.$store.dispatch("loadingHandler", true);

      const qry = {
        Page_Size: 1,
        Page_Num: 1,
        SearchText: [unicomnm],
      };
      console.log("getCompanyDetail", qry);

      try {
        const res = await this.$api.apibidmain.search_bidmain(qry);
        if (res.total > 0) {
          console.log("companyDetail", res.data);
          this.companyDetail = res.data[0];
          if (this.companyDetail.au_brand_name) {
            // 品牌名稱, 是陣列型態, 但會有name=="無" 的資料, 或是"" , 需要過濾掉
            this.companyDetail.au_brand_name = this.companyDetail.au_brand_name.filter((x) => x.name && x.name != "無");
          }
          // 設定dataSelectedDate 為最新的DataDt
          this.dataSelectedDate = this.companyDetail.DataDt;
        } else {
          notify({
            title: "查無公司資料",
            message: `統一編號 ${unicomnm} 查無公司資料`,
            type: "error",
          });
        }
      } catch (err) {
        handleError(err, {
          title: "錯誤",
          message: "查詢失敗，請稍後再試",
          type: "error",
        });
      }
      this.$store.dispatch("loadingHandler", false);
    },

    getNationTaxDataDt(unicomnm) {
      console.log("取得稅籍資料日期", unicomnm);
      // 取得最新資料日期
      const qry = {
        Page_Size: 50,
        Page_Num: 1,
        UniComNm: unicomnm,
      };
      return this.$api.apidata
        .get_nation_tax(qry)
        .then((res) => {
          // console.log("nationTaxDataDt", res);
          if (res && res.data && res.data.length > 0) {
            this.nationTaxList = res.data;
            this.dataHistoryList = [...new Set(res.data.map((item) => item.DataDt))];
            // this.dataHistoryList 必須按照日期由新到舊排序
            this.dataHistoryList.sort((a, b) => (b || "").localeCompare(a || ""));
          }
        })
        .catch((err) => {
          handleError(err, {
            title: "錯誤",
            message: "查詢失敗，請稍後再試",
            type: "error",
          });
        });
    },

    // 決定那些頁籤要顯示
    showTabs() {
      // console.log("companyDetail in showTabs", this.companyDetail);
      // 稅籍, 出進口,工廠, 供應商,  投資, 陸資, 赴大陸 ,獲獎, 認證,  領域, 商標, 園區, 裁罰, 關聯新聞, 公司概況表
      let tabsShow = [true, false, false, false, false, false, false, false, false, false, false, false, false, true, false];
      const detail = this.companyDetail;
      // 出進口
      if (detail.au_is_import || detail.au_is_export) tabsShow[1] = true;
      // 工廠
      if (detail.au_is_factory) tabsShow[2] = true;
      // 供應商
      if (detail.au_is_supplier) tabsShow[3] = true;
      // 投資
      if (detail.au_invest_area) tabsShow[4] = true;
      // 陸資來臺投資
      if (detail.au_is_china_fund) tabsShow[5] = true;
      // 赴中國大陸投資
      if (detail.au_is_invest_china) tabsShow[6] = true;
      // 獲獎名稱
      if (detail.au_award_name) tabsShow[7] = true;
      // 認證名稱
      if (detail.au_certification) tabsShow[8] = true;
      // 領域名稱
      if (detail.au_domain_name) tabsShow[9] = true;
      // 商標
      if (detail.au_brand_name) tabsShow[10] = true;
      // 所在園區
      if (detail.au_park_name) tabsShow[11] = true;
      // 裁罰警示
      if (detail.au_alarm_item) tabsShow[12] = true;

      // 公司概況表
      // console.log("detail.au_is_existing_customer", detail.au_is_existing_customer);
      // 新增一個限制, 如果menuFlatter中的Menu有包括"公司概況表", 才顯示公司概況表的頁籤, 否則不顯示
      let mList = JSON.parse(window.localStorage.getItem("menuFlatter"));
      const hasComBrief = mList.some((x) => x.Name == "公司概況表");
      console.log("hasComBrief", hasComBrief);
      if (detail.au_is_existing_customer && detail.au_is_existing_customer.length > 0 && hasComBrief) tabsShow[14] = true;
      else tabsShow[14] = false;

      this.tabsList = [
        { name: "稅籍", show: tabsShow[0], datasource: "" },
        { name: "出進口", show: tabsShow[1], datasource: "" },
        { name: "工廠", show: tabsShow[2], datasource: "" },
        { name: "供應商", show: tabsShow[3], datasource: "" },
        { name: "投資", show: tabsShow[4], datasource: "" },
        { name: "陸資來臺投資", show: tabsShow[5], datasource: "" },
        { name: "赴中國大陸投資", show: tabsShow[6], datasource: "" },
        { name: "獲獎名稱", show: tabsShow[7], datasource: "" },
        { name: "認證名稱", show: tabsShow[8], datasource: "" },
        { name: "領域名稱", show: tabsShow[9], datasource: "" },
        { name: "品牌商標", show: tabsShow[10], datasource: "" },
        { name: "所在園區", show: tabsShow[11], datasource: "" },
        { name: "裁罰警示", show: tabsShow[12], datasource: "" },
        { name: "關聯新聞", show: tabsShow[13], datasource: "" },
        { name: "公司概況表", show: tabsShow[14], datasource: "" },
      ];
    },

    yearFormat: function(value) {
      if (value === null || value.length < 4) return "";
      else {
        return value.slice(0, 4) + "年";
      }
    },

    async doShowDetail() {
      this.profileList = [];

      let fields = [
        { key: "ComLoc", title: "營業地址" },
        { key: "HQUniComNm", title: "總機構統一編號" },
        { key: "UniComNm", title: "統一編號" },
        { key: "ComName", title: "營業人名稱" },
        { key: "Cap", title: "資本額" },
        { key: "ApvDt", title: "設立日期" },
        { key: "ComType", title: "組織別名稱" },
        { key: "Voice", title: "使用發票" },
        { key: "IndusType", title: "行業名稱" },
        { key: "IndusNm", title: "行業代號" },
        { key: "DataSource", title: "資料來源" },
      ];

      let result = this.companyDetail;
      console.log("nationTaxList before format", this.nationTaxList);
      result.fulladdress = this.fullAddress;

      // 組合 IndusType，只在有值時才加上 "/"
      let indusTypes = [result.IndusType, result.IndusType1, result.IndusType2, result.IndusType3].filter((type) => type && type !== null && type !== "").join(" / ");
      result.IndusType = indusTypes;

      // 組合 IndusNm，只在有值時才加上 "/"
      let indusNms = [result.IndusNm, result.IndusNm1, result.IndusNm2, result.IndusNm3].filter((nm) => nm && nm !== null && nm !== "").join(" / ");
      result.IndusNm = indusNms;

      // console.log("companyDetail before format", result);

      result.DataSource = "財政部財政資訊中心(" + this.dataSelectedDate + ")";

      for (let field of fields) {
        if (result[field.key]?.length) {
          if (field.title == "資本額") {
            // 資本額需要加上千分位逗號
            result[field.key] = parseInt(result[field.key]).toLocaleString();
          }
          if (field.title == "營業地址") {
            // 同地址公司數以超連結呈現，點擊新分頁回到 ctm 以地址關鍵字查詢
            const sameAddressCount = Number(result["SameAddressCount"] || 0);
            if (sameAddressCount > 1) {
              const addressText = String(result[field.key] || "");
              const encodedAddress = encodeURIComponent(addressText);
              const countText = `共${sameAddressCount}家公司`;
              this.profileList.push({
                title: field.title,
                value: `${addressText} (${countText})`,
                isHtml: true,
                htmlValue: `${addressText} (<a href="javascript:void(0)" onclick="window.vueComponent.handleSameAddressClick('${encodedAddress}')" style="color: #409EFF; text-decoration: underline;">${countText}</a>)`,
              });
              continue;
            }
          }
          this.profileList.push({ title: field.title, value: result[field.key] });
        }
      }

      // console.log("updated profileList:", result);
      this.FullComName = result.ComName;

      const DeptID = this.userInfo?.DeptID || "";
      // console.log("DeptID=" + DeptID);
      // 開始處理自訂標籤
      // let brValues = Object.keys(result)
      //     .filter(key => key.startsWith('br_'))
      //     .reduce((acc, key) => acc + ' ' + result[key], ' ');

      // console.log("result", result);

      // 先呈現既有客戶
      if (result["au_is_existing_customer"] && result["au_is_existing_customer"].length > 0) this.profileList.push({ title: "既有客戶(*)", value: result["au_is_existing_customer"][0].name });

      // 開始處理總行標籤
      {
        let hqValues = result["hq_category"];
        if (hqValues?.length && hqValues != "null") {
          let htmlValues = [];
          hqValues.forEach((tag) => {
            // console.log("tag=" + tag);
            const tagStr = tag.name || "";
            htmlValues.push(`<a href="javascript:void(0)" onclick="window.vueComponent.handleTagClick('${tagStr}','${tag.category}', '總行標籤')" style="margin-right: 8px; color: #409EFF; text-decoration: underline;">${tagStr}</a>`);
          });
          this.profileList.push({
            title: "總行標籤(*)",
            value: hqValues,
            isHtml: true,
            htmlValue: htmlValues.join(" / "),
          });
        }
      }

      // 開始處理自訂標籤
      {
        let brValues = result["br_category"];

        if (brValues?.length && brValues != "null") {
          // console.log("brValues", brValues);
          let htmlValues = [];
          brValues.forEach((tag) => {
            // console.log("tag=" + tag);
            const tagStr = tag.name || "";
            htmlValues.push(`<a href="javascript:void(0)" onclick="window.vueComponent.handleTagClick('${tagStr}','${tag.category}', '自訂標籤')" style="margin-right: 8px; color: #409EFF; text-decoration: underline;">${tagStr}</a>`);
          });
          this.profileList.push({
            title: "自訂標籤(*)",
            value: brValues,
            isHtml: true,
            htmlValue: htmlValues.join(" / "),
          });
        }
      }

      // 開始處理標準標籤
      let au_fields = [
        { key: "au_company_type", title: "公司類別" },
        { key: "au_phone", title: "公司電話" },
        { key: "au_mobile", title: "公司行動電話" },
        { key: "au_mail", title: "公司信箱" },
        { key: "au_is_import", title: "進口資格" },
        { key: "au_is_export", title: "出口資格" },
        { key: "au_is_factory", title: "設立工廠" },
        { key: "au_is_supplier", title: "有供應商" },
        { key: "au_invest_area", title: "對外投資", isHyperlink: true },
        { key: "au_is_china_fund", title: "陸資來台投資", isHyperlink: true },
        { key: "au_is_invest_china", title: "赴中國大陸投資", isHyperlink: true },
        { key: "au_award_name", title: "獲獎記錄", isHyperlink: true },
        { key: "au_certification", title: "專業認證", isHyperlink: true },
        { key: "au_domain_name", title: "企業領域", isHyperlink: true },
        { key: "au_brand_name", title: "品牌商標", isHyperlink: true },
        { key: "au_park_name", title: "所在園區", isHyperlink: true },
        { key: "au_alarm_item", title: "裁罰警示", isHyperlink: true },
        { key: "au_industry", title: "相關產業", isHyperlink: true },
        { key: "au_industry_type", title: "相關產業", isHyperlink: true },
        { key: "au_product", title: "相關產品", isHyperlink: true },
        // {key: 'hq_category', title: '總行標籤', isHyperlink: true},
      ];

      for (let field of au_fields) {
        if (result[field.key]) {
          if (Array.isArray(result[field.key])) {
            if (result[field.key].length == 0) continue;
            // 是陣列
            if (field.isHyperlink) {
              // 需要做超連結
              let htmlValues = [];
              //console.log("result[field.key]", result[field.key]);
              // 如果 tag 包含 event_date，先依照 event_date 做 desc 排序，再迭代
              let tagsToIterate = result[field.key];
              if (Array.isArray(tagsToIterate) && tagsToIterate.some((t) => t && t.event_date)) {
                tagsToIterate = tagsToIterate.slice().sort((a, b) => {
                  const ta = a && a.event_date ? new Date(a.event_date).getTime() : -Infinity;
                  const tb = b && b.event_date ? new Date(b.event_date).getTime() : -Infinity;
                  return tb - ta;
                });
              }
              tagsToIterate.forEach((tag) => {
                const tagStr = tag.display_name || tag.name || tag;
                let tagCategory = tagStr;
                // if (tag.category == "invest_area" || tag.category == "is_invest_china" || tag.category == "is_china_fund") {
                //     tagCategory = `${tag.event_date ? this.yearFormat(tag.event_date) : ''} ${tag.name || ''}`
                // }
                htmlValues.push(`<a href="javascript:void(0)" onclick="window.vueComponent.handleTagClick('${tagCategory}','${tag.category}', '標準標籤')" style="margin-right: 8px; color: #409EFF; text-decoration: underline;">${tagCategory}</a>`);
              });
              //console.log("htmlValues", htmlValues);
              this.profileList.push({
                title: field.title + "(*)",
                value: result[field.key].join(" / "),
                isHtml: true,
                htmlValue: htmlValues.join(" / "),
              });
            } else {
              // 不需要超連結, 但還是一個陣列, tag物件有 name 屬性
              this.profileList.push({
                title: field.title + "(*)",
                value: result[field.key]
                  .map((item) => item?.display_name || item?.name || item)
                  .filter((v) => v !== null && v !== undefined && String(v).trim() !== "")
                  .join(" / "),
              });
            }
          } // 是字串
          else {
            // console.log("處理字串欄位", field.key);
            alert("處理字串欄位, 目前還沒有測試有的案例......");
            if (result[field.key].length == 0) continue;

            if (field.isHyperlink) {
              // 需要做超連結
              let htmlValues = [];
              let tags = result[field.key].split(/\s*,\s*|\s+/);
              tags.forEach((tag) => {
                const tagStr = tag;
                htmlValues.push(`<a href="javascript:void(0)" onclick="window.vueComponent.handleTagClick('${tagStr}','${tag.category}', '標準標籤')" style="margin-right: 8px; color: #409EFF; text-decoration: underline;">${tagStr}</a>`);
              });
              this.profileList.push({
                title: field.title + "(*)",
                value: result[field.key],
                isHtml: true,
                htmlValue: htmlValues.join(" / "),
              });
            } else {
              this.profileList.push({ title: field.title + "(*)", value: result[field.key] });
            }
          }
        }
      }
    },
  },

  async mounted() {
    // 將 Vue 實例暴露到 window 對象，以便 onclick 事件可以訪問
    window.vueComponent = this;

    this.userInfo = this.$store.state.userInfo;
    // 取得公司統編
    this.unicomnm = this.$route.query.unicomnm;

    // 打API取得公司資料, 會把祥細資料放在 this.companyDetail
    await this.getCompanyDetail(this.unicomnm);
    // 取得稅籍資料日期
    await this.getNationTaxDataDt(this.unicomnm);

    // 決定那些頁籤要顯示
    this.showTabs();
    this.doShowDetail();

    // console.log("this.dataHistoryList", this.dataHistoryList);
    if (this.dataHistoryList && this.dataHistoryList.length > 0) {
      console.log("this.dataHistoryList[0]", this.dataHistoryList[0]);
      this.dataSelectedDate = this.dataHistoryList[0];
      this.selectedDate = this.dataHistoryList[0];
      // 執行 handleDateChange , 會把 this.selectedDate 的值傳入, 以便取得該日期的稅籍資料
      this.handleDateChange(this.selectedDate);
    } else {
      this.selectedDate = "";
    }

    if (this.FullComName && String(this.FullComName).trim()) {
      document.title = `標籤資訊-${this.FullComName}`;
    }
    this.getFunction();

    this.showMap();
  },
  created() {},

  beforeDestroy() {
    // 清理 window 對象中的 Vue 實例引用
    if (window.vueComponent === this) {
      delete window.vueComponent;
    }
  },
};
</script>

<style lang="scss" scoped>
// * {
//     outline: 1px solid red;
// }

.tagsClass {
  margin-right: 10px;
  border: 1px solid #ddd;
}

#map {
  width: 100%;
  height: 500px;
  border: 1px solid #000;
}
.comRelBox {
  background: linear-gradient(-135deg, #fff 20%, #fff 50%, transparent 50%) center center / 100% 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  .dialogBox {
    display: flex;
    flex-direction: column;
    width: 90%;
    padding: 5px 5%;

    .upperBox {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;

      label {
        width: 100px;
        white-space: nowrap;
        margin-right: 10px;
        text-align: right;
      }
    }

    .lowerBox {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;

      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
      }
      .el-radio-group .el-radio {
        flex: 0 0 25%; /* 控制每行顯示四個選項 */
        margin-top: 10px;
      }
    }
  }

  .searchWrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0px 5%;

    .row1 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          //   text-align: right;
        }
      }
    }

    .row2 {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: -30px;
      justify-content: flex-start;

      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }
  }

  .tabsBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 0px 5%;
  }

  .buttonBox {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 12px;
  }

  .taxContent {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start;

    // padding: 0px 5%;
    .contentLeft {
      width: 40%;
    }
    .contentRight {
      width: 55%;
    }
  }

  .overviewContent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-top: 20px;
    width: 100%;

    .exportBox {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 100%;
    }

    .section {
      display: flex;
      flex-direction: column;
      margin: 0 0;
      background: #fff;
      border-radius: 5px;
      width: 100%;

      .sectionItem {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding: 15px;

        .itemTitle {
          width: 120px;
          font-weight: bold;
          color: #333;
        }

        .itemValue {
          width: calc(33.33% - 120px - 30px);
          margin-right: 30px;
          color: #666;
        }
      }
    }

    .section2,
    .section3,
    .section4 {
      display: flex;
      flex-direction: column;
      margin: 0px 0 0 0;
      background: #fff;
      border-radius: 5px;
      width: 100%;
    }

    .sectionHeaderRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .unitText {
      font-size: 14px;
      margin-bottom: 0px;
      text-align: right;
    }
  }

  @media (max-width: 1200px) {
    .taxContent {
      flex-direction: column;

      .contentLeft,
      .contentRight {
        width: 100%;
      }
    }
  }

  .pageBox {
    display: flex;
    flex-direction: columns;
    justify-content: flex-end;
    padding: 0px 5%;
  }

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
  }
}

::v-deep .el-table .credit-subtotal-row > td {
  background: #fff6ef !important;
  font-weight: bold;
  text-decoration: underline;
}

::v-deep .el-table th > .cell {
  font-size: 14px;
}

::v-deep .el-table td.align-right-column > .cell {
  text-align: right;
}
</style>
